'use strict';
const angular = require('angular');
import * as ControlProperties from '../../app/localStorage/Controls/Controls';
import * as Props from '../../app/localStorage/Props';
const uiRouter = require('angular-ui-router');
const geoTools = require('../../assets/scripts/vendor/geotools2.js');
const _ = require('lodash');
// Angular Drag and drop library (https://github.com/marceljuenemann/angular-drag-and-drop-lists)
require('angular-drag-and-drop-lists');

import routes from './create.routes';
import HtmlSourceComponent from './html-source/html-source.component';
import { Ids as ACTION_IDS } from '../../components/constants/action.constants';
import * as moment from 'moment';
(<any>window).validate = function () { };
(<any>window).getData = function () { };
(<any>window).noopMethod = function () { };

(<any>window).getPropValue = function (controlName, propName) { };
(<any>window).setPropValue = function (controlName, propName, propValue) { };
(<any>window).getPropValueByDataFieldName = function (controlName) { };
(<any>window).setPropValueByDataFieldName = function (controlName, propValue, uid, force) { };
(<any>window).resetRepeatingTableValue = function (controlName) { };
(<any>window).getDateDifference = function (dateControlName1, dateControlName2) { };
(<any>window).getDateTimeDifference = function (dateTimeControlName1, dateTimeControlName2, dateTimeFormat) { };
(<any>window).addOrSubtractDate = function (dateControlName, operator, days) { };

(<any>window).getSystemFieldValue = function (systemField) {};
(<any>window).compareSystemFieldValue = function (systemField, comparator, value, type) {};
(<any>window).setAutoNumbering = function (autoNumberField, autoNumberLength, autoNumberStartFrom, autoNumberPosition, autoNumberSeparator, autoNumberTitle, isAutoNumbering) {};
(<any>window).globleMethod = function (dateControlName, operator, days) { };
(<any>window).getMinmaxDateValue  = function (minmax_datevalue, controlStr) { };
(<any>window).repeatingTableFunctionality  = function (functionality, controlName, index, scopeData, IndexValue, showCheck, ReadOnlyCheck) { };
(<any>window).getFormViewDetail = function (projectName, appbuilderID, dp_DOC_ASSOC, dp_ORI_FWD_DOC_ASSOC, dp_FORM_ASSOC, dp_FORM_ASSOC_CURRENT, ds_ATTACH_AUTOASSOCIATE_MSG, dp_ATTACH_ALL_MSG, callbackFn, dp_FORM_ASSOC_ORI, dp_All_FORM_ASSOC_CURRENT, dp_ALL_FORM_ASSOC, dp_DOC_ASSOC_CURRENT, dp_DOC_ASSOC_ALL_MSG, dp_ATTACH_ORI_MSG, dp_ATTACH_CURRENT_MSG) { };

(<any>window).mergeDataFromAPI = function(apiName,callbackFn) { };
(<any>window).locationAssociationCallback = function (callbackFn) { };
(<any>window).getCustomResponse = function(prop,responseData, optionMap, optionMapName) { };
(<any>window).setAlertMsg = function (msgText) { };
(<any>window).checkForExternalAssociations = function (callbackFn) { };
(<any>window).addWorkingDays = function (control_name, dropdown_operator, Days) { };
(<any>window).addWorkingDaysForCustomDate = function (source_field_name, control_name, dropdown_operator, Days) { };

export class CreateComponent {

  models: any; //HTML element models
  templateComponents: any // HTML template models
  selectedType: string;
  myText: String; //Form HTML output.
  store: any; //Localstorage instance
  selectedView: any;
  views: any;
  $http: any;
  $timeout: any;
  $window: any;
  params: any;
  ngNotification: any;
  defaultView = {
    editing: false,
    controls: {
      'A': []
    },
    viewName: ''
  };
  loading: boolean;
  $state: any;
  $filter: any;
  copiedItems: any;
  $scope: any;
  Util: any;
  LanguageObject: any;
  $rootScope: any;
  config: any;
  dateOptions: any = {
    formatDay: 'dd',
    formatMonth: 'MMM',
    formatYear: 'yyyy',
    showWeeks: false
  };
  timePickerOptions :any
  timeFormat:string = 'HH:mm';
  datePickerOptions :any
  filterOption: any;
  $uibModal: any;
  $document: any;
  maps: any;
  private _googleMapsLoadPromise: Promise<void> | null = null;
  showHelpPopup: boolean;
  editTempName: boolean;
  tempTemplateName: any
  external: any;
  multiHeight: any;
  controlToRemove: any;
  selectedControlToRemove: any;
  geoCoder: any;
  published: boolean;
  viewsDataFromServer: any;
  mousemoved: boolean;
  oldformatOptions:any;
  formScript: string;
  savedChanges: boolean = true;
  hideSideBar: boolean = true;
  printTypeText: string = '';
  $anchorScroll;
  $location;
  showScrollToTop: boolean = false;
  counterService: any;
  validatorRegEx: any = {
    Alphanumeric : /^[\w-\\.\s]+$/,
    Numeric : /^-?\\d+(\\.\\d+)?$/,
    Email : /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    Decimal : /^(-)?(?:\d*\.)?\d+$/,
    Integer : /^(-)?\d+$/,
    Letters : /^[a-zA-Z-\\._\s]+$/i
  };
  numberFormatEnabled: boolean = false;
  showFlag: boolean = false;
  wrapTextTimeOut: any;
  pasteAsCalculatedWithoutFlag = ['Layout', 'Section', 'Table', 'RepeatingTable'];

  typeWiseDataFieldNameAllowed: any = {
    'Attachment': ['Attachment'],
    'Signature': ['Signature'],
    'Rich-Text-Box': ['Rich-Text-Box'],
    'Textbox': ['Textbox', 'Text-Area'],
    'Text-Area': ['Textbox', 'Text-Area'],
    'Map': ['Map'],
    'Dropdown': ['Dropdown'],
    'Datepicker': ['Datepicker'],
    'Checkbox': ['Checkbox'],
    'Radio': ['Radio'],
    'ToggleButton':['ToggleButton'],
    'MultiDropdown': ['MultiDropdown'],
    'Timepicker': ['Timepicker'],
    'InlineAssocFiles': ['InlineAssocFiles'],
    'InlineAssocApps': ['InlineAssocApps'],
    'ViewAssociations': ['ViewAssociations']
  };

  proeprtyPathMap: any = {
    "value": "Basic.Value.selectedValue",
    "text": "Basic.Text.selectedValue",
    "label": "Basic.Label.selectedValue",
    "required": "Basic.Required.selectedValue",
    "multiSelect": "Basic.Multi-Select.selectedValue",
    "displayFormat": "Basic['Display Format'].selectedValue",
    "time":"Basic['Time'].selectedValue",
    "hourFormat": "Basic['Time Format'].selectedValue",
    "readOnly": "Display['Read-only'].selectedValue",
    "hidden": "Display.Hidden.selectedValue",
    "options": "['Data Source'].table.list",
    "placeHolder": "Display['Place Holder'].selectedValue",
    "charLimit": "Display.Char-Limit.selectedValue",
    "size": "Size.Rows.selectedValue",
    "width": "Size.Width.selectedValue",
    "height": "Size.Height.selectedValue",
    "border-top-color": "Style.style-group.members.font-color",
    "borderColor": "Borders.border-style-group.members.border-color.selectedValue",
    "borderWidth": "Borders.border-style-group.members.border-width.selectedValue",
    "reapeatingBorderColor": "Borders.border-style-group.members.border-color.selectedValue",
    "reapeatingBorderWidth": "Borders.border-style-group.members.border-width.selectedValue",
    "layoutBorderWidth": "Display.Border.selectedValue",
    "tooltip": "Advance.Tooltip.selectedValue",
    "validate": "Advance.Basic.selectedValue",
    "padding-top": "Margin.margin-top.selectedValue",
    "padding-bottom": "Margin.margin-bottom.selectedValue",
    "padding-left": "Margin.margin-left.selectedValue",
    "padding-right": "Margin.margin-right.selectedValue",
    "font-size": "Style.font-style-group.members.font-size.selectedValue",
    "font-family": "Style.font-style-group.members.font-family.selectedValue",
    "font-weight": "Style.style-group.members.bold.selectedValue",
    "font-style": "Style.style-group.members.italic.selectedValue",
    "text-decoration": "Style.style-group.members.underline.selectedValue",
    "text-align": "Style.style-group.members.alignment.selectedValue",
    "background-color": "Style.font-style-group.members.background-color.selectedValue",
    "color": "Style.style-group.members.font-color.selectedValue",
    "label-font-size": "Style.font-style-group.members.font-size.selectedValue",
    "label-font-family": "Style.font-style-group.members.font-family.selectedValue",
    "label-font-weight": "Style.style-group.members.bold.selectedValue",
    "label-font-style": "Style.style-group.members.italic.selectedValue",
    "label-text-decoration": "Style.style-group.members.underline.selectedValue",
    "label-text-align": "Style.style-group.members.alignment.selectedValue",
    "label-background-color": "Style.font-style-group.members.background-color.selectedValue",
    "label-color": "Style.style-group.members.font-color.selectedValue",
    "control-font-size": "ControlStyle.font-style-group.members.font-size.selectedValue",
    "control-font-family": "ControlStyle.font-style-group.members.font-family.selectedValue",
    "control-font-weight": "ControlStyle.style-group.members.bold.selectedValue",
    "control-font-style": "ControlStyle.style-group.members.italic.selectedValue",
    "control-text-decoration": "ControlStyle.style-group.members.underline.selectedValue",
    "control-text-align": "ControlStyle.style-group.members.alignment.selectedValue",
    "control-color": "ControlStyle.style-group.members.font-color.selectedValue",
    "background-color-on":"SwitchToggleStyle.background-color-on.selectedValue",
    "background-color-off":"SwitchToggleStyle.background-color-off.selectedValue",
    "background-color-even": "EvenOddRowStyle.background-color-on.selectedValue",
    "background-color-odd": "EvenOddRowStyle.background-color-off.selectedValue",
    "label-on": "Basic.LabelOn.selectedValue",
    "label-off": "Basic.LabelOff.selectedValue",
    "value-on": "Basic.ValueOn.selectedValue",
    "value-off": "Basic.ValueOff.selectedValue",
    "displayLabel": "Basic.DisplayLabel.selectedValue",
  };
  apiConnections : any;

  /**
   * Code editor instance
   *
   * @type {*}
   * @memberof CreateComponent
   */
  codeEditor: any;

  globleScript: any;
  $translate: any;

  selectedTheme: any = 1;
  themeChanged: any = 0;
  isPuppeteerViewEnabled: string = "false";
  addAppType: number = 0;
  isLandscape: string = "false";
  formProperties: any = {
    "theme": 1,
    "isThemeChanged": 0,
    "addAppType": 0,
    "isPuppeteerWithAngularViewEnabled": false,
    "isLandscape": "false"
  };
  designStyle: any = {};

  readOnlyControlsToUpdate: any = [];
  controlPropertyChangedDebouncer: any;
  selectedItemDomain : any= [];
  selectedItemIndex;
  selectedItemView;
  publishWarn : any = false;

  messageHandler(e){
    if(!e.data || typeof e.data !== 'string') {
      return;
    }
    if(e.data.indexOf('callAppDesigner|') > -1) {
      let result : any = JSON.parse(e.data.split('|')[1]);
      if(result.funcName) {
        let fn : any = window[result.funcName];
        if(fn) {
          result.data = fn();
          e.source.postMessage('callAppDesigner|' + JSON.stringify(result), e.origin);
        }
      }
    }
  }
  /*@ngInject*/
  constructor(localStorage, $http, $window, $stateParams, Notification, $state, $filter, $scope, Util, $rootScope, config, $uibModal, $document, $anchorScroll, $location, $timeout, counterService,$translate) {
    let self = this;
    this.counterService = counterService;
    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.showHelpPopup = false;
    this.$uibModal = $uibModal;
    this.$document = $document;
    this.config = config;
    this.$rootScope = $rootScope;
    this.Util = Util;
    this.$scope = $scope;
    this.$filter = $filter;
    this.params = $stateParams.params;
    this.published = false;
    this.editTempName = false;
    this.tempTemplateName = '';
    this.$state = $state;
    this.copiedItems = [];
    this.mousemoved = true;
    this.$translate = $translate;
    if (!this.params) {
      this.$state.go('main');
      return;
    }
    this.external = config.external;
    this.$window = $window;
    this.$http = $http;
    this.$timeout = $timeout;
    this.store = localStorage;
    this.models = this.store.get('components');
    this.templateComponents = this.store.get('templates');
    this.selectedType = 'controls';
    this.models.selected = null;
    this.selectedView = this.store.get('selectedView');
    this.views = this.store.get('views');
    this.selectedView.view = this.views[Object.keys(this.views)[0]];
    this.ngNotification = Notification;
    this.loading = false;
    this.LanguageObject = this.store.get('Languages');
    this.viewsDataFromServer = '';
    this.getNumberFormatingEnabledData(() => {
      self.getFormDesignData();
    });
    this.multiHeight = 9;
    this.filterOption = {
      objAttrList: {},
      objRelationList: {},
      resetOption: {},
      filterList: {}
    };
    this.timePickerOptions = {
      showMeridian :true,
    };
    this.datePickerOptions = {
        format:this.Util.getNewDateFormat('default'),
        showClear:true,
        showClose:true,
        showTodayButton:true,
        sideBySide:true,
        useCurrent:false,
        toolbarPlacement: "bottom",
        locale: window.navigator.language.split('_')[0],
        icons: {
          close: 'closeText',
          clear: 'clearText',
          today: 'todayText'
        }
    }

    $rootScope.$on('onViewChange', (event) => {
      $timeout(() => {
        self.gotoTop();
      }, 500)
    });

    self.controlPropertyChangedDebouncer = _.debounce(() => {
      self.processToUpdateReadOnlyControlProperties();
    }, 3000);

    self.$rootScope.$on('controlPropertyChanged', (event, fieldName) => {
      if(fieldName && self.readOnlyControlsToUpdate.indexOf(fieldName) == -1) {
        self.readOnlyControlsToUpdate.push(fieldName);
      }
      self.controlPropertyChangedDebouncer();
    });

    this.oldformatOptions = [
      {
          value: 'default',
          key: 'Default'
      }, {
          value: 'dd-M-yy',
          key: 'dd-mmm-yyyy'
      }, {
          value: 'dd-mm-yy',
          key: 'dd-mm-yyyy'
      }, {
          value: 'dd-mm-y',
          key: 'dd-mm-yy'
      }, {
          value: 'mm-dd-yy',
          key: 'mm-dd-yyyy'
      }, {
          value: 'mm-dd-y',
          key: 'mm-dd-yy'
      }, {
          value: 'dd/mm/y',
          key: 'dd/mm/yy'
      }, {
          value: 'dd/mm/yy',
          key: 'dd/mm/yyyy'
      }];
    let numberReg = /^-?\d+\.?\d*$/;

    this.$document.off('dragover.g dragenter.g').on('dragover.g dragenter.g', function (e) {
      self.setStyle(e);
    });
    this.$document.off('mousemove.g').on('mousemove.g', function (e) {
      self.removeStyle(e);
    });
    $timeout(function () {
      let scrollTimeout;
      angular.element('.dnd-main-container .scroller').bind('scroll', function (e) {
        let scrollTop = e.target.scrollTop;
        scrollTimeout && $timeout.cancel(scrollTimeout);
        scrollTimeout = $timeout(function () {
          self.showScrollToTop = scrollTop == 0 ? false : true;
        }, 100);
      })

      // getting the control drop area
      const keyupElement = angular.element(document.querySelector('.container-fluid .row.drop-area'));
      keyupElement[0].focus();
      keyupElement.on('keydown', function(event) { // initializing keydown event
        const isEditable = event.target.isContentEditable;
        // Check if the platform is macOS
          const isMac = navigator.platform.includes('Mac');

          // Determine the correct modifier key based on the OS
          const modifierKey = isMac ? event.metaKey : event.ctrlKey;

        if(self.config.for != 'Marketplace' && !isEditable && modifierKey && event.key === 'c' || event.key === 'C') {
            self.copy(false);
        } else if(self.config.for != 'Marketplace' &&  !isEditable && event.ctrlKey && event.key === 'v') {
          self.paste();
        }
      });
    }, 100);
    (<any>window).validate = function () {
      let valid = {
        valid: true,
        defaultMissing: [],
        notValidInput: [],
        defaulValuetMissing: []
      };
      if (self.views && self.views.ORI_VIEW) {
        let controls = self.views.ORI_VIEW.controls.A;
        valid = self.Util.validate(controls, valid);
      }
      return valid;
    };
    (<any>window).getData = function () {
      let views = angular.copy(self.views);
      /* if (angular.equals(angular.copy(self.viewsDataFromServer), views)) {
        return '';
      } */
      return views;
    };

    self.$window.localStorage.getItem('domXml') && self.$window.localStorage.removeItem('domXml'); // Removes the previous set blockly from the localStorage

    window.removeEventListener('message',this.messageHandler,false);
    window.addEventListener('message',this.messageHandler,false);

    (<any>window).getPropValue = function (controlName, propName) {
      if(!controlName || !propName) {
        console.error('Please pass valid control name or property name. ', controlName, propName);
        return '';
      }

      let propPath = self.proeprtyPathMap[propName] || '';
      if(!propPath) {
        console.error('Can not found property path from property name. Property name: ', controlName, propName);
        return '';
      }

      let properties = self.getPropertiesFromControlName(controlName);
      if(!properties) {
        console.error('Can not found properties from control name. Control Name: ', controlName);
        return '';
      }

      if(propName == 'value') {
        let controlType = properties.Basic.ControlType;
        if(controlType == 'Checkbox' || controlType == 'Radio') {
          let options = _.get(properties, "['Data Source'].table.list", []);
          let selectedItemsVal = [];
          options.forEach((item) => {
            if(item.selectedValue && item.selectedValue.name) {
              selectedItemsVal.push(item.Value.name)
            }
          });
          return selectedItemsVal.join(', ');
        }else if(controlType == 'Map' || controlType == 'Datepicker' || controlType == 'Timepicker') {
          propPath = "Basic.Default.selectedValue";
        }

        let val = angular.copy(_.get(properties, propPath, ''));
        return val;
      }
      return angular.copy(_.get(properties, propPath, ''));
    };

    (<any>window).getPropValueByDataFieldName = function (dataFieldName) { 
      if(!dataFieldName) {
        console.error('Please pass valid data field name. ', dataFieldName);
        return;
      }
      
      let controlList = self.getControlsByDataFieldName(dataFieldName);
      if(controlList.length) {
        let fieldName = controlList[0].properties.Basic && controlList[0].properties.Basic['Field Name'] && controlList[0].properties.Basic['Field Name'].selectedValue;
        return (<any>window).getPropValue(fieldName, 'value');
      }
    };

    var setControlPropValue = function(properties, propName, propValue,control) {
      if(!properties || !propName) {
        console.error('Please pass valid properties or property name. ', properties, propName);
        return;
      }
      
      let propPath = self.proeprtyPathMap[propName] || '';
      if(!propPath) {
        console.error('Can not found property path from property name. Property name: ', propName);
        return;
      }

      if(propValue == undefined) {
        propValue = '';
      }

      
      let controlType = properties.Basic.ControlType;
      let oldVal;
      if(propName == 'value') {
        if(controlType == 'Map') {
          propPath = "Basic.Default.selectedValue";
        }
        if(propValue.indexOf && propValue.indexOf('$#$#$#') != -1) {
          propValue = propValue.replace(/\$\#\$\#\$\#/g, '\n');
        }
        if(controlType == 'Radio' || controlType == 'Checkbox') {
          oldVal = _.get(properties, propPath, []);
          let oldPropValue = propValue || '';
          propPath = "['Data Source'].table.list";
          propValue = angular.copy(_.get(properties, "['Data Source'].table.list", []));
          propValue.forEach((item) => {
            if(oldPropValue.indexOf(item.Value.name) != -1) {
              item.selectedValue.name = true;
            }else {
              item.selectedValue.name = '';
            }
          });
        } else if(controlType == 'Datepicker') {
          propPath = "Basic.Default.dateObj";
          oldVal = _.get(properties, propPath, '');

          let dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? 'DD-MMM-YYYY' : properties.Basic['Display Format'].selectedValue;
          if(properties.Basic['Time'] && properties.Basic['Time'].selectedValue)  {
              dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
          }
          let dateVal = moment(propValue).format(dateTimeFormat);
         if(dateVal == 'Invalid date') {
            dateVal = '';
            propValue = dateVal;
        }
        _.set(properties, 'Basic.Default.selectedValue', dateVal);
          // if(propValue.split) {
          //   let dateVal = self.Util.parseDate(properties.Basic['Display Format'].selectedValue, propValue);
          //   if(dateVal == 'Invalid Date') {
          //     let dateItems = propValue.split('-');
          //     if(dateItems.length == 3) {
          //       dateVal = new Date(dateItems[0], dateItems[1], dateItems[2]);
          //       if(dateVal == 'Invalid Date') {
          //         dateVal =  '';  
          //       }
          //     }else {
          //       dateVal =  '';
          //     }
          //   }
          //   propValue = dateVal;
          // }
        }
        else if(controlType == 'Timepicker') {
          propPath = "Basic.Default.selectedValue";
          oldVal = _.get(properties, propPath, '');
        }
        else if(controlType == 'Attachment') {
          oldVal = _.get(properties, propPath, '');
          if(typeof propValue != 'object' || propValue['@inline'] == undefined || propValue['content'] == undefined) {
            propValue = '';
          }
        }else if(controlType == 'Signature') {
          oldVal = _.get(properties, propPath, '');
          if(typeof propValue != 'object' || propValue.length != 2) {
            propValue = '';
          }
        }else if(controlType == 'MultiDropdown') {
          oldVal = _.get(properties, propPath, []);
          let newVal = [];
          let controlOptions = angular.copy(_.get(properties, "['Data Source'].table.list", []));
          for(let i = 0;i < propValue.length;i++) {
            if(controlOptions.some(item => (item.Value.name).includes(propValue[i]) )) {
              newVal.push(propValue[i]);
            }

          }
          propValue = newVal;
        }
        else {
          oldVal = _.get(properties, propPath, '');
        }
      }

      if(propName == 'options') {
        oldVal = _.get(properties, propPath, []);

        let newOptios = propValue;
        if(typeof propValue == 'string') {
          if(propValue.indexOf('[') != -1 && propValue.indexOf(']') != -1) {
            propValue = propValue.replace('[', '').replace(']', '');
            let valArray = propValue.split(',');
            newOptios = [];
            valArray.forEach(item => {
              newOptios.push(item.replace(/'/g, '').trim());
            });
          }else {
            newOptios = propValue.split(',');
          }
        }

        if(newOptios.length == 0 || !newOptios.forEach) {
          return;
        }
        propValue = [];
        newOptios.forEach((name, index) => {
          let option = angular.copy(oldVal[0]);
          option.id = index;
          option.Label.name = name;
          option.Value.name = name;
          option.selectedValue && (option.selectedValue.name = false);
          propValue.push(option);
        });

        if(controlType == 'Dropdown' || controlType == 'MultiDropdown') {
          let valPropPath = self.proeprtyPathMap['value'];
          _.set(properties, valPropPath, '');
        }
      }

      _.set(properties, propPath, propValue);
      if(controlType == 'Checkbox' || controlType == 'Radio') {
        self.getListItems(control,properties);
      }

      //Don't set any proerpty via script logic as of now so mark this line as commented
      /* if(propName == 'value' && properties.Events && properties.Events.change && !angular.equals(oldVal, propValue)) {
        $timeout(function() {
          self.onEvent(properties.Events.change.selectedValue);
        }, 100);
      } */
      
    };
    
    (<any>window).getSystemFieldValue = function (systemField) {
      return self.Util.getValueOfOnLoadData(systemField);
    };

    (<any>window).setPropValueByDataFieldName = function (dataFieldName, propValue, excludedControlId, force) {
      //Don't set any proerpty via script logic as of now so mark this line as commented
      if(!force) {
        return;
      }
      if(!dataFieldName) {
        console.error('Please pass valid data field name. ', dataFieldName);
        return;
      }
      
      let controlList = self.getControlsByDataFieldName(dataFieldName);
      controlList.forEach((control) => {
        if(excludedControlId && (control.uid == excludedControlId)) {
          return;
        }
        setControlPropValue(control.properties, 'value', propValue, control);
      });
    };


    if (!this.config.external) {
      (<any>window).onbeforeunload = function (e) {
        var dialogText = "There may be unsaved data. Please save before you leave else your changes will be lost.";
        e.returnValue = dialogText;
        return dialogText;
      };
    }
    this.$scope.goBack = function () {
      if (self.config.showListing == true) {
        self.$state.go('main');
      } else if (self.config.for == 'Marketplace') {
        window.top.postMessage('closeWindowMarketplace', "*");
      } else {
        (<any>window).onbeforeunload = function () { };
        self.$window.close();
      }
    }
    this.$scope.publish = function () {
      self.publish();
    }
    this.$scope.publishWarn = function () {
      self.publishWarn = false;
    }

    let formID = this.params.id || null;
    let projectId = this.params.id.projectId ? this.params.id.projectId : undefined;
    let instanceGroupId = this.params.id.instanceGroupId;
    if (this.config.for != 'Marketplace' && this.config.for != 'Meta-Data') {
      let apiList = self.Util.getAllAPIConnections(formID,instanceGroupId,projectId);
      // let apiConnections = [];
      apiList.then(function (response) {
        const data = angular.copy(response.data.entity) || []
        self.apiConnections = data;
      }, function (err) {
        console.log(err);
        self.apiConnections = [];
      });
    }

    this.designStyle = ACTION_IDS.DESIGN_STYLE;

    self.$document.on('keyup', (event) => {
      self.onKeyUp(event);
      self.$scope.$apply();
    });

    this.$document.on('keydown', (event) => {
      self.onKeyDown(event);
      self.$scope.$apply();
    });
  
  };

  processToUpdateReadOnlyControlProperties(clearDebouncer?) {
    let self = this;
    self.$timeout(() => {
      self.readOnlyControlsToUpdate.forEach((fieldName) => {
        self.Util.refreshReadOnlyControlsPropeties(fieldName);
      });
      
      if(clearDebouncer && self.controlPropertyChangedDebouncer) {
        self.controlPropertyChangedDebouncer.cancel();
      }
      self.readOnlyControlsToUpdate.length = 0;
    });
  }

  getPropertiesFromControlName(controlName) {
    let self = this;
    if(!self.views) {
      return;
    }

    let controls = self.Util.getAllControls();
    let properties = undefined;
    controls.length && controls.forEach((control) => {
      if(!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'].selectedValue == controlName) {
        properties = control.properties;
      }
    });
    return properties;
  };

  getPropertiesFromDataFieldName(dataFieldName) {
    let self = this;
    if(!self.views) {
      return;
    }

    let controls = self.Util.getAllControls();
    let properties = undefined;
    controls.length && controls.forEach((control) => {
      if(!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
        properties = control.properties;
      }
    });
    return properties;
  };

  getControlsByFieldName(fieldName) {
    let self = this;
    if(!self.views) {
      return;
    }

    let controls = self.Util.getAllControls();
    let controlList = [];
    controls.length && controls.forEach((control) => {
      if(!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue == fieldName) {
        controlList.push(control);
      }
    });
    return controlList;
  }

  getControlsByDataFieldName(dataFieldName) {
    let self = this;
    if(!self.views) {
      return;
    }

    let controls = self.Util.getAllControls();
    let controlList = [];
    controls.length && controls.forEach((control) => {
      if(!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
        controlList.push(control);
      }
    });
    return controlList;
  }

  getControlType(controlName) {
    let self = this;
    if(!self.views) {
      return;
    }

    let controlType = undefined;
    let controls = self.Util.getAllControls();
    controls.length && controls.forEach((control) => {
      if(control.properties.Basic && control.properties.Basic['Field Name'].selectedValue == controlName) {
        controlType = control.properties.Basic.ControlType;
      }
    });
    return controlType;
  };

  gotoTop() {
    document.getElementById('top').focus();
  };

  getSelectedItemsIncluding(list, item) {
    if (this.config.for == 'Marketplace') {
      this.ngNotification.error({
        message: 'Dragging not allowed.', positionX: 'center', replaceMessage: true
      });
      return;
    }
    item.selected = true;
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    if (selected.length) {
      for (let i = 0; i < selected.length; i++) {
        selected[i].dragging = true;
      }
    }
    this.$rootScope.$broadcast('closeTimepickerToggle');
    return selected;
  };

  /**
     * @brief      Gets the selected item.
     *
     * @return     The selected item.
     */
   getSelectedItem() {
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    return (selected.length == 1) ? selected[0] : {};
   }

   selectItem(item, event, list, index) {
    this.selectedItemDomain = list;
    this.selectedItemIndex = index;
    this.selectedItemView = this.selectedView.view.viewName;
    this.deselectAllOtherViews();
    //setting parent node id for textbox or display field if added under repeating table    
    if(item && (item.type.toLowerCase() == "textbox" || item.type.toLowerCase() == "display field"))
      this.updateChildId(item,event);
    // Check if the platform is macOS
    const isMac = navigator.platform.includes('Mac');

    // Determine the correct modifier key based on the OS
    const modifierKey = isMac ? event.metaKey : event.ctrlKey;
    if (!modifierKey) {
      let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
      if (selected.length && !event.shiftKey) {
        for (let i = 0; i < selected.length; i++) {
          selected[i].selected = false;
          if(item.properties.Basic['Field Name'].selectedValue != selected[i].properties.Basic['Field Name'].selectedValue){
            this.clearAllCell();
          }
        }
      }
      if (!event.shiftKey){
        item.selected = true;
      }else if( selected.length == 0 && (item.type == "Table" || item.type == "RepeatingTable" || item.type == "Layout")) {
        item.selected = true;
      }
    } else {
      item.selected = !item.selected;
    }
    this.$rootScope.$broadcast('controlChanged');
  }

  broadcastDesignChange() {
    this.$rootScope.$broadcast('designChanged');
  }

  broadcastNewDesign() {
    this.$rootScope.$broadcast('newDesgin');
  }

  onDrop(list, items, index) {
    let self = this;
    let viewName = this.selectedView.view.viewName || '';
    this.savedChanges = false;
    if (angular.isArray(items)) {
      for (let i = 0; i < items.length; i++) {
        delete items[i].dragging;
        items[i].selected = false;
        list.splice(parseInt(index) + i, 0, items[i]);
        items[i].viewName = viewName;

        if(items[i] && (items[i].type.toLowerCase() == "textbox" || items[i].type.toLowerCase() == "display field"))
          this.updateChildId(items[i],event);
        else if(items[i] && (items[i].type.toLowerCase() == "repeatingtable")){
          var tableElems = angular.element("div[type=RepeatingTable]");
          var tableElemsIDs = [];
          for(let i =0;i<tableElems.length;i++){
            let currentTblId = parseInt(angular.element(tableElems[i]).attr("repeating-table-id"));
            if(tableElemsIDs.indexOf(currentTblId) == -1) tableElemsIDs.push(currentTblId);
          }
          if(tableElemsIDs.indexOf(items[i].id) != -1)
          items[i].id = tableElems.length + 1;
        }
      }
    } else {
      delete items.dragging;
      items.selected = false;
      list.splice(index, 0, items);
      (!items.uid) ? items.uid = self.Util.getGUID() : '';
      items.viewName = viewName;

      if(items && (items.type.toLowerCase() == "textbox" || items.type.toLowerCase() == "display field"))
        this.updateChildId(items,event);
      else if(items && (items.type.toLowerCase() == "repeatingtable")){
        var tableElems = angular.element("div[type=RepeatingTable]");
        var tableElemsIDs = [];
        for(let i =0;i<tableElems.length;i++){
          let currentTblId = parseInt(angular.element(tableElems[i]).attr("repeating-table-id"));
          if(tableElemsIDs.indexOf(currentTblId) == -1) tableElemsIDs.push(currentTblId);
        }
        if(tableElemsIDs.indexOf(items.id) != -1)
        items.id = tableElems.length + 1;
      }
    }
    return true;
  }

  removeDragging() {
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    if (selected.length) {
      for (let i = 0; i < selected.length; i++) {
        delete selected[i].dragging;
      }
    }
  }

  removeDraggedItems(field) {
    let self = this;
    switch (field.type) {
      case 'Layout':
        self.Util.accessLayoutElements(field, function (elems) {
          for (var i = elems.length - 1; i >= 0; i--) {
            if (elems[i].dragging) {
              elems.splice(i, 1);
              continue;
            } else {
              self.removeDraggedItems(elems[i]);
            }
          }
        });
        break;
      case 'Table':
        self.Util.accessTableElements(field, function (elems) {
          for (var i = elems.length - 1; i >= 0; i--) {
            if (elems[i].dragging) {
              elems.splice(i, 1);
              continue;
            } else {
              self.removeDraggedItems(elems[i]);
            }
          }
        });
        break;
      case 'RepeatingTable':
        self.Util.accessRepeatingTableElements(field, function (elems) {
          for (var i = elems.length - 1; i >= 0; i--) {
            if (elems[i].dragging) {
              elems.splice(i, 1);
              continue;
            } else {
              self.removeDraggedItems(elems[i]);
            }
          }
        });
        break;
      case 'Section':
        self.Util.accessSectionElements(field, function (elems) {
          for (var i = elems.length - 1; i >= 0; i--) {
            if (elems[i].dragging) {
              elems.splice(i, 1);
              continue;
            } else {
              self.removeDraggedItems(elems[i]);
            }
          }
        });
        break;
    }
  }

  onMoved() {
    let list = this.selectedView.view.controls.A;
    if (list.length) {
      for (var i = list.length - 1; i >= 0; i--) {
        if (list[i].dragging) {
          list.splice(i, 1);
          continue;
        } else {
          this.removeDraggedItems(list[i]);
        }
        
        if(list[i].parent)
        delete list[i].parent;
      }
    }
    this.selectedView.view.controls.A = list;
    this.savedChanges = false;
    this.broadcastDesignChange();
  }

  executeGlobleScript() {
    let self = this;
    if(self.globleScript && self.globleScript.scriptVal) {
      try {
        (<any>window).eval(self.globleScript.scriptVal);
      } catch(e) {
        console.error('Error when execute on globle scripts: ', e);
      }
    }
    window['globle'] = self.globleScript;
  }

  getNumberFormatingEnabledData(callback) {
    this.$http({
      'url': (<any>window).properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + ACTION_IDS.GET_NUMBER_FORMAT_ENABLED_DETAIL,
      'method': "POST",
      'withCredentials': true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }).then(response => {
      let isEnabled = (response.data == "true"  || response.data == true);
      this.store.set("numberFormatEnabled", isEnabled);
      this.numberFormatEnabled = isEnabled;
      this.$rootScope.$broadcast('numberFormatEnabledChanged');
      callback();
    }, response => {
      this.store.set("numberFormatEnabled", false);
      this.numberFormatEnabled = false;
      this.$rootScope.$broadcast('numberFormatEnabledChanged');
      callback();
    });
  }

  getFormDesignData() {
    let self = this;
    let data: any = {};
    let method = 'GET';
    let url = (<any>window).properties.service.uri + ACTION_IDS.GET_FORM_VIEW_JSON + this.params.id + '?ver=' + Math.random();
    if(self.params.id.projectId){
      self.params.formName = decodeURIComponent(self.params.formName);
    }else {
      self.params.formName = decodeURIComponent(encodeURIComponent(self.params.formName));
    }
    self.params.extraParams = this.config && this.config.for == 'Marketplace' ? this.config.formDetail.extra : '';
    self.config['formID'] = self.params.id;
    if (self.config.for == "Meta-Data") {
      url = (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_FOLDER_META_DATA;
      method = 'POST';
      data = {
        projectId: this.params.id.projectId,
        folderId: this.params.id.folderId,
        isForEdit: this.params.id.isForEdit
      };
      if (data.folderId == 0 || data.folderId == '0') {
        delete data.folderId;
      }
    }

    if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
      let formTypeId = this.params.id.formTypeId || this.params.id.formTypeID;
      url = (<any>window).properties.service.commonApiUrl + ACTION_IDS.GET_FORM_VIEW_JSON_BY_FORM_TYPE + formTypeId + '/' + this.params.id.projectId + '?ver=' + Math.random();
    }

    if (self.config.for == "Direct-Design") {
      self.Util.getProjectCustomAttributeSet(this.params.id.projectId);
    }

    this.loading = true;
    this.$http({
      'url': url,
      'method': method,
      'data': data,
      'withCredentials': true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      },
    }).then(response => {
      self.$timeout(() => {
        self.loading = false;
        self.gotoTop();
      }, 500);
      
      let data = response.data.entity;
      self.published = data.published;
      let views = Object.keys(self.views);
      let languageData = JSON.parse(data.languageData);
      this.setCounter(data);

      // for new style design changes
      let formProperties = data.formProperties ? JSON.parse(data.formProperties) : {};
      self.isPuppeteerViewEnabled = formProperties.hasOwnProperty('isPuppeteerWithAngularViewEnabled') ? JSON.stringify(formProperties.isPuppeteerWithAngularViewEnabled) : self.isPuppeteerViewEnabled;
      self.printTypeText = JSON.parse(self.isPuppeteerViewEnabled) ? 'advance.printing' : 'basic.printing';
      self.addAppType = formProperties.hasOwnProperty("addAppType") ? formProperties.addAppType : 0;
      self.isLandscape = formProperties.hasOwnProperty("isLandscape") ? JSON.stringify(formProperties.isLandscape) : self.isLandscape;
      let theme = 1;
      if (formProperties && formProperties.hasOwnProperty("addAppType")) {
        theme = 2;
      }
      theme = formProperties.hasOwnProperty("theme") ? formProperties.theme : theme;
      let isThemeChanged = formProperties.hasOwnProperty("isThemeChanged") ? formProperties.isThemeChanged : 0;
      self.themeChanged  = formProperties.hasOwnProperty("isThemeChanged") ? formProperties.isThemeChanged : 0;
      self.changeTheme(theme);

      if (views.length) {
        for (let i = 0; i < views.length; i++) {
          delete self.views[views[i]];
        }
      }

      if (data.formViewJson) {
        let viewsFromJson = JSON.parse(data.formViewJson);
        let controlsWithProperties = this.models.items;
        if (Object.keys(viewsFromJson).length) {
          for (let view in viewsFromJson) {
            if (!viewsFromJson[view].removeOnLoad) {
              self.views[view] = viewsFromJson[view];
            } else {
              self.removeLanguageLabels(view, languageData);
            }
          }
        }
      } else {
        let defaultName = angular.copy(self.defaultView)
        defaultName.viewName = 'ORI_VIEW';
        self.views['ORI_VIEW'] = defaultName;
        self.Util.addSubjectField(self.views['ORI_VIEW']);
      }

      if(data.formScript) {
        try {
          self.globleScript = JSON.parse(data.formScript) || {};
        }catch(e) {
          self.globleScript = {};
        }
      }else {
        self.globleScript = {};
      }

      //Set here to update code during migration step
      window['globle'] = self.globleScript;

      //Do migration for all views control one time
      self.doInitialMigration();

      self.executeGlobleScript();

      self.viewsDataFromServer = angular.copy(self.views);
      self.store.set('Languages', languageData);
      self.selectedView.view = self.views[Object.keys(self.views)[0]];
      this.prepareJsonForHierarchy(this.selectedView.view.controls.A);
      this.broadcastNewDesign();
      this.broadcastDesignChange();
      window.top.postMessage('appDesignerLoadingComplete', "*");
      self.$timeout(() => {
        if (self.config.sectionAvailibility && self.config.sectionAvailibility.components) {
          if (angular.element("div[id='ORI_FORMTITLE']").length > 0) {
            angular.element("div[id='ORI_FORMTITLE']").hide();
          }
          if (self.config.for == 'Marketplace') {
            window.top.postMessage('loadingComplete', "*");
          }
          self.openTemplateDialog('reviewcomponent');
        }
      }, 500);
    }, response => {
      self.loading = false;
      switch (response.status) {
        case 401:
          self.ngNotification.error({ message: 'Unauthorized access', positionX: 'center', replaceMessage: true });
          break;
        case 503:
          self.ngNotification.error({ message: 'Service Temporary unavailable', positionX: 'center', replaceMessage: true });
          break;
        case 500:
          self.ngNotification.error({ message: 'Internal Server Error', positionX: 'center', replaceMessage: true });
          break;
        case -1:
          self.ngNotification.error({ message: 'Connectivity Issue', positionX: 'center', replaceMessage: true });
          break;
        case 403:
          self.ngNotification.error({ message: 'Session Timeout', positionX: 'center', replaceMessage: true });
          break;
      }
    });
  }

  setCounter(data) {
    for (const control in this.counterService.counter) {
      if (this.counterService.counter.hasOwnProperty(control)) {
        delete this.counterService.counter[control];
      }
    }
    if (data.counter) {
      angular.merge(this.counterService.counter, JSON.parse(data.counter));
    }
    this.counterService.triggerChangeCallBack();
  }

  mergeProperties(controls, controlsWithProperties) {
    let self = this;
    if (controls.length) {
      for (let i = 0; i < controls.length; i++) {
        let control = controlsWithProperties.filter(function (val) {
          return val.type == controls[i].type;
        })
        controls[i] = angular.merge({}, control[0], controls[i]);
        if (controls[i].type == "Layout") {
          self.Util.accessLayoutElements(controls[i], function (elems) {
            self.mergeProperties(elems, controlsWithProperties);
          });
        }
        if (controls[i].type == "Table") {
          self.Util.accessTableElements(controls[i], function (elems) {
            self.mergeProperties(elems, controlsWithProperties);
          });
        }
        if (controls[i].type == "RepeatingTable") {
          self.Util.accessRepeatingTableElements(controls[i], function (elems) {
            self.mergeProperties(elems, controlsWithProperties);
          });
        }
        if (controls[i].type == "Section") {
          self.Util.accessSectionElements(controls[i], function (elems) {
            self.mergeProperties(elems, controlsWithProperties);
          });
        }
      }
    }
  }

  logEvent(message, event) {
    console.log(message, '(triggered by the following', event.type, 'event)');
    console.log(event);
  };

  removeFromList(item, list) {
    let self = this;
    if (angular.isArray(item) && item.length) {
      for (let i = 0; i < item.length; i++) {
        let index;
        list.filter(function (val, j) {
          if (val == item[i])
            index = j;
        });
        typeof index != "undefined" && list.splice(index, 1);
      }
    } else {
      this.controlToRemove = {
        item: item,
        list: list
      };
      this.$scope.removeTitle = function () {
        self.removeTitle();
      };
      this.$scope.removeCopied = function () {
        self.removeCopied();
      };
      if (_.get(item, "properties.Basic['Data Field Name'].selectedValue", '') == 'ORI_FORMTITLE') {
        let msg = self.$translate.instant('warning.before.remove.title')
        this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });

      } else {
        let fieldValue = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
        let isThisCopied = this.Util.finddeep(this.views, { copiedFrom: fieldValue });
        let isThisDeriveded = this.Util.finddeep(this.views, { selectedValue: `{{${fieldValue}}}` });
        if ((isThisCopied || isThisDeriveded) && fieldValue !== '') {
          this.ngNotification.warning({
            message: 'warning.before.remove.copied', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_copied.html", scope: this.$scope
          });
        } else {
          this.ngNotification.warning({
            message: 'warning.before.remove.control', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_control.html", scope: this.$scope
          });
        }
      }
    }
    self.$rootScope.$broadcast('closeTimepickerToggle');
  }

  removeTitle() {
    this.removeCopied(true);
  }

  removeCopied(exclude?, broadcast = true) {
    let self = this;
    let controlToRemoveCopied = self.controlToRemove;
    if (!controlToRemoveCopied) {
      return;
    }
    let index;
    controlToRemoveCopied.list.filter(function (val, i) {
      if (val == controlToRemoveCopied.item)
        index = i;
    });

    let extraFieldTobeReset = [];
    let allChilds = [];
    if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Layout') {
      self.Util.accessLayoutElements(controlToRemoveCopied.item, (elems) => {
        allChilds = self.Util.getIteams(elems, allChilds);
        allChilds.forEach((childElem) => {
          extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''))
        });
      });
    }

    if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Table') {
      self.Util.accessTableElements(controlToRemoveCopied.item, (elems) => {
        allChilds = self.Util.getIteams(elems, allChilds);
        allChilds.forEach((childElem) => {
          extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''))
        });
      });
    }
    if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'RepeatingTable') {
      self.Util.accessRepeatingTableElements(controlToRemoveCopied.item, (elems) => {
        allChilds = self.Util.getIteams(elems, allChilds);
        allChilds.forEach((childElem) => {
          extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''))
        });
      });
    }

    if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Section') {
      self.Util.accessSectionElements(controlToRemoveCopied.item, (elems) => {
        allChilds = self.Util.getIteams(elems, allChilds);
        allChilds.forEach((childElem) => {
          extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''))
        });
      });
    }

    typeof index != "undefined" && controlToRemoveCopied.list.splice(index, 1);

    if (!controlToRemoveCopied.item.copiedFrom) {
      let fieldValue = _.get(controlToRemoveCopied.item, "properties.Basic['Field Name'].selectedValue", '');
      for (var view in self.views) {
        var controls = self.views[view].controls.A;
        if (!exclude) {
          controls = self.removeObj(controls, fieldValue);
        }
        extraFieldTobeReset.forEach((fieldName) => {
          if (fieldName) {
            controls = self.removeObj(controls, fieldName);
          }
        });
        self.views[view].controls.A = controls;
      }
    }

    if (controlToRemoveCopied.item.copiedFrom && index == undefined) {
      controlToRemoveCopied.list.filter(function (val, i) {
        if (self.pasteAsCalculatedWithoutFlag.indexOf(val.type) > -1) {
          if (val.type === 'Layout') {
            _.forEach(val.data, function (column) {
              column.elems[0] = _.filter(column.elems[0], function (control) {
                if (control == controlToRemoveCopied.item) {
                  return false;
                }
                return true;
              });
            });
          }
          else if (val.type === 'Section') {
            val.data.elems[0] = _.filter(val.data.elems[0], function (control) {
              if (control == controlToRemoveCopied.item) {
                return false;
              }
              return true;
            });
          }
          else if (val.type === 'Table') {
            _.forEach(val.data, function (row) {
              _.forEach(row, function (column) {
                column.elems[0] = _.filter(column.elems[0], function (control) {
                  if (control == controlToRemoveCopied.item) {
                    return false;
                  }
                  return true;
                });
              });
            });
          }
          else if (val.type === 'RepeatingTable') {
            _.forEach(val.data, function (row) {
              _.forEach(row, function (column) {
                column.elems[0] = _.filter(column.elems[0], function (control) {
                  if (control == controlToRemoveCopied.item) {
                    return false;
                  }
                  return true;
                });
              });
            });

            _.forEach(val.footer_data, function (row) {
              _.forEach(row, function (column) {
                column.elems[0] = _.filter(column.elems[0], function (control) {
                  if (control == controlToRemoveCopied.item) {
                    return false;
                  }
                  return true;
                });
              });
            });

            _.forEach(val.header_data, function (row) {
              _.forEach(row, function (column) {
                column.elems[0] = _.filter(column.elems[0], function (control) {
                  if (control == controlToRemoveCopied.item) {
                    return false;
                  }
                  return true;
                });
              });
            });
          }
        }
      });
    }

    if (broadcast) {
      self.broadcastDesignChange();
    }
  }

  removeObj(list, fieldValue) {
    var self = this;
    let controlToRemoveCopied = self.controlToRemove;
    var result = _.filter(list, function (control) {
      if ((control == controlToRemoveCopied.item) ||
        (control.copiedFrom && !control.pasteAsCalculated && control.copiedFrom === fieldValue) ||
        (control.pasteAsCalculatedFrom && control.pasteAsCalculated && control.pasteAsCalculatedFrom === fieldValue) ||
        (control.pasteAsCalculatedFrom && self.pasteAsCalculatedWithoutFlag.indexOf(control.type) > -1 && control.pasteAsCalculatedFrom === fieldValue)) {
        return false;
      }
      else {
        if (control.type === 'Table') {
          _.forEach(control.data, function (row) {
            _.forEach(row, function (column) {
              column.elems[0] = self.removeObj(column.elems[0], fieldValue);
            });
          });
        }

        if (control.type === 'Layout') {
          _.forEach(control.data, function (column) {
            column.elems[0] = self.removeObj(column.elems[0], fieldValue);
          });
        }

        if (control.type === 'Section') {
          control.data.elems[0] = self.removeObj(control.data.elems[0], fieldValue);
        }

        if (control.type === 'RepeatingTable') {
          _.forEach(control.data, function (row) {
            _.forEach(row, function (column) {
              column.elems[0] = self.removeObj(column.elems[0], fieldValue);
            });
          });

          _.forEach(control.footer_data, function (row) {
            _.forEach(row, function (column) {
              column.elems[0] = self.removeObj(column.elems[0], fieldValue);
            });
          });

          _.forEach(control.header_data, function (row) {
            _.forEach(row, function (column) {
              column.elems[0] = self.removeObj(column.elems[0], fieldValue);
            });
          });
        }

        if (_.get(control, "properties.Basic['Value'].selectedValue", '') === `{{${fieldValue}}}`) {
          /*if (control.type === 'Display field'){
             _.set(control, "derivedFromFieldName", '');
          }
          if (control.type === 'RepeatingTable'){
            _.set(control, "properties.Basic['DSName'].selectedValue", '');
         }
          return _.set(control, "properties.Basic['Value'].selectedValue", '');*/
          return false;
        }
        return control.copiedFrom !== fieldValue;
      }
    });
    return result;
  }

  showPropertybox() {
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    if (this.config.for == 'Meta-Data' && selected.length == 1 && (selected[0].type == 'Datepicker' || selected[0].type == 'Map' || selected[0].type == 'Radio'|| selected[0].type == 'Timepicker')) {
      return false;
    }
    return (selected.length == 1);
  }

  onToggle(property) {
    property.Basic.Value.selectedValue = !property.Basic.Value.selectedValue;
  }

  setMultiDDSelection(item,selectedItem) {
    selectedItem['isSelected'] = selectedItem.isSelected  == undefined ? true: !selectedItem.isSelected;
    if(selectedItem.isSelected) {
      if (item.properties.Basic.ControlType === "Dropdown") {
        if (item.properties.Basic["Multi-Select"].selectedValue) {
          if (!item.properties.Basic.Value.selectedValue.includes(selectedItem.Value.name)) item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name)
          else {
            const index = item.properties.Basic.Value.selectedValue.indexOf(selectedItem.Value.name);
            if (index > -1) {
              item.properties.Basic.Value.selectedValue.splice(index, 1);
            }
          }
        } else {
          item.properties.Basic.Value.selectedValue = [];
          item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name)
        }

        if (!item.properties.Basic["Multi-Select"].selectedValue) {
          item.properties["Data Source"].table.list.forEach(element => {
            if (element.id != selectedItem.id)
              element.isSelected = false;
          });
        }
      } else {
        item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name);
      }
      
    } else {
      for (var i = 0; i < item.properties.Basic.Value.selectedValue.length; i++) {
        var sitem = item.properties.Basic.Value.selectedValue[i];
        if(selectedItem.Value.name == sitem) {
          item.properties.Basic.Value.selectedValue.splice(i, 1);
          break;
        }
      }
    }
  }

  clearMultiDropdownSearch(item) {
    //clear search value
    item.properties.Basic.searchText = '';
    item.properties.Basic.isLimited = true;
    this.initialDropdownPosition(item);
  }
  clearMultiDropdown(item) {
    //clear selection
    item.properties.Basic.Value.selectedValue = [];
    let options =  item.properties["Data Source"].table.list;
    for (var i = 0; i < options.length; i++) {
      options[i].isSelected = false;
    }
  }
  closeMultiDropdown(item, clickPoint) {
    if(!(clickPoint == 'dropdownList' && item.properties.Basic["Multi-Select"].selectedValue)){
      item.properties.Basic.isOpen = false;
      item.properties.Basic.isLimited = true;
    }
  }

  onMultiDropdownToggle(item,event) {
    let selectionArr = [],
    nonSelectedArr = [];
    item.properties.Basic.isLimited = true;
    let options =  item.properties["Data Source"].table.list;
    if(item.properties.Basic.isOpen) {
      item.properties.Basic.searchText = '';
      for (var i = 0; i < options.length; i++) {
        if((item.properties.Basic.Value.selectedValue).includes(options[i].Value.name)) {
          options[i].isSelected = true;
        } else {
          options[i].isSelected = false;
        }
      }
      for(var y = 0; y < options.length; y++) {
        if(options[y].isSelected) {
          selectionArr.push(options[y]);
        } else {
          nonSelectedArr.push(options[y]);
        }
      }
      item.properties["Data Source"].table.list = selectionArr.concat(nonSelectedArr);
    }
    this.initialDropdownPosition(item);
  }
  initialDropdownPosition(item) {
     //calculate position for multidropdown display if at the end of the screen / or not sufficient space

     var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
     var curDropdownHeight = minHeight + (28 * listLen);
     curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
     var windowHeight = $(window).innerHeight();
     var pageScroll = $('body').scrollTop();
     var curElement = angular.element('div[data-name=' + item.uid + ']');
     var offset = curElement.offset();
     var toppos = offset.top;
     var space = windowHeight - (offset.top - pageScroll);
     if (space < curDropdownHeight) {
       pos = (toppos - curDropdownHeight) + 'px';
     } else {
       pos = (toppos + 34) + 'px';
     }
     var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
     dropdownMenuElem[0].style.top = pos;
  }
  showAll(item) {
    item.properties.Basic.isLimited = false;

    //calculate position for multidropdown display if at the end of the screen / or not sufficient space
    var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
    var curDropdownHeight = minHeight + (28 * listLen);
    curDropdownHeight = curDropdownHeight > 397 ? 397 : curDropdownHeight;
    var windowHeight = $(window).innerHeight();
    var pageScroll = $('body').scrollTop();
    var curElement = angular.element('div[data-name=' + item.uid + ']');
    var offset = curElement.offset();
    var toppos = offset.top;
    var space = windowHeight - (offset.top - pageScroll);
    if (space < curDropdownHeight) {
      pos = (toppos - curDropdownHeight) + 'px';
    } else {
      pos = (toppos + 34) + 'px';
    }
    var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
    dropdownMenuElem[0].style.top = pos;
  }

  updateDropdownPosition(item) {
    this.postionDropdownOnSearch(item);
  }

  postionDropdownOnSearch(item) {
    //calculate position for multidropdown display if at the end of the screen / or not sufficient space
    var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
    var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
    var curDropdownHeight = minHeight + (28 * listLen);
    curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
    var windowHeight = $(window).innerHeight();
    var pageScroll = $('body').scrollTop();
    var curElement = angular.element('div[data-name=' + item.uid + ']');
    var offset = curElement.offset();
    var toppos = offset.top;
    var space = windowHeight - (offset.top - pageScroll);
    if (space < curDropdownHeight) {
      if(dropdownMenuElem.height()) {
        pos = (toppos - (dropdownMenuElem.height()) - 10) + 'px';
      } else {
        pos = (toppos - curDropdownHeight) + 'px';
      }
    } else {
      pos = (toppos + 34) + 'px';
    }

    dropdownMenuElem[0].style.top = pos;
  }
  downloadZip(): void {
    let self = this;
    if (self.editTempName) {
      self.editTempNameCancle();
    }

    if (self.params.formName.match(/[|<>\\/:?*"'$#]/gi)) {                
      self.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
      return;  
    }

    let timeStamp = new Date().getTime();
    this.validateAndSave(function () {
      let data :any;
      let downloadURL : any;
      if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
        let formTypeID =  self.params.id.formTypeId || self.params.id.formTypeID;
        let instanceGroupId = self.params.id.instanceGroupId;
        let extraParams = self.params.extraParams ? JSON.stringify(self.params.extraParams) : '';
        self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
        self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
        self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
        data = {
          "timeStamp": timeStamp,
          "formTypeId": formTypeID,
          "projectId": self.params.id.projectId,
          "instanceGroupId": instanceGroupId,
          "for": self.config.for,
          "name": self.params.formName,
          "extraParams": extraParams,
          "formProperties": JSON.stringify(self.formProperties)
        };
      } else {
        self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
        self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
        self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
        self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
        self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
        data  = {
          "id": self.params.id,
          "name": self.params.formName,
          "timeStamp": timeStamp,
          "formProperties": JSON.stringify(self.formProperties)
        };
      }
      downloadURL = 'download';
      self.Util.downloadZip(downloadURL, data);
    }, true);
  }

  validate(viewData = {}): {status: boolean, message: string | string[], allControls: any[],  hasTwoAutoNumbering?: boolean} {
    let _this = this;
    let protectedParams = this.Util.getProtectedParams();
    let isValid = true;
    let message = [];
    let detectAutoNumbering = {
      oldAutoNumbering: false,
      advanceAutoNumbering: false
    }
    let allControls = [];

    if(_this.globleScript && _this.globleScript.hasOwnProperty('scriptVal') && _this.globleScript.scriptVal.includes('window.setAutoNumbering && window.setAutoNumbering(')) {
      detectAutoNumbering.oldAutoNumbering = true
    } 

    if(_this.globleScript && _this.globleScript.hasOwnProperty('scriptVal') && _this.globleScript.scriptVal.includes('window.setAutoNumberingSuffix && window.setAutoNumberingSuffix(')) {
      detectAutoNumbering.advanceAutoNumbering = true;
    }

    if(detectAutoNumbering.oldAutoNumbering && detectAutoNumbering.advanceAutoNumbering) {
      return {status: false, message: 'Only one Auto-Numbering block can be used, please delete the required block to publish/save/download the zip',  allControls: [], hasTwoAutoNumbering: true}
    }
    
    if (Object.keys(viewData).length) {
      let fieldNameAcrossViews = [],allcontrolsAry = [];
      for(let view in viewData){
        for(let v=0;v<this.Util.getIteams(viewData[view].controls.A).length;v++){
          allcontrolsAry.push(this.Util.getIteams(viewData[view].controls.A)[v]);
        }
      }
      for (let view in viewData) {
        let controls = this.Util.getIteams(viewData[view].controls.A);
        let viewName = this.Util.getLanguageSpecificViewName(view);
        if (controls.length) {
          let fieldNames = [];
          let dataFieldNames = [];
          for (let i = 0; i < controls.length; i++) {
            let syncappstatus = false, synccloseddate = false;
            let control = controls[i];

                        // checking for the autonumbering events on the controls

                        if(control.properties && control.properties.Events) {

                          const eventsCopy = angular.copy(control.properties.Events);
            
                          for(let [event, eventData] of Object.entries(eventsCopy)) {
            
                            const selectedValue = eventData.selectedValue;
            
                            if(selectedValue && selectedValue.includes('window.setAutoNumbering && window.setAutoNumbering(')) {
                              detectAutoNumbering.oldAutoNumbering = true;
                            }
            
                            if(selectedValue && selectedValue.includes('window.setAutoNumberingSuffix && window.setAutoNumberingSuffix(')) {           
                              detectAutoNumbering.advanceAutoNumbering = true;
                            }

                            if(detectAutoNumbering.oldAutoNumbering && detectAutoNumbering.advanceAutoNumbering) {              
                              return {status: false, message: 'Only one Auto-Numbering block can be used, please delete the required block to publish/save/download the zip',  allControls: [], hasTwoAutoNumbering: true};
                            }
                          }
                        }

            let label = control.properties.Basic && (control.properties.Basic.Label || control.properties.Basic.Text) && (control.properties.Basic.Label || control.properties.Basic.Text).selectedValue || '';
            if (this.Util.controlsWithoutFieldName.indexOf(control.type) == -1) {

              if(control.type == "Dropdown" && control.properties.Advance['App Status']){
                syncappstatus = control.properties.Advance['App Status'].selectedValue;
              }
              
              //If more than one datepicker is used with enable closed date sync, setting this validation msg
              if(control.type == "Datepicker" && control.properties.Advance['Closed Date']){
                synccloseddate = control.properties.Advance['Closed Date'].selectedValue;
                if(synccloseddate){
                  try{
                    //validate closed due date for past dates
                    if(control.properties.Basic.Default.selectedValue != "" && control.properties.Basic.Default.dateType == 1){
                      var dateformat = (control.properties.Basic["Display Format"].selectedValue == "default") ? "DD-MMM-YYYY" : control.properties.Basic["Display Format"].selectedValue;
                      var formatedDate = moment(control.properties.Basic.Default.selectedValue,dateformat).toDate();
                      if(formatedDate.setHours(0,0,0,0) < new Date().setHours(0,0,0,0)) {
                        message.push("'Close Due Date' cannot be a past date. <br>")
                      }
                    }
                  }catch(e){}
                }
              }
              
              let fieldName = control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
              var labelAndFieldName = label ? (fieldName ? label + ' - ' + fieldName : label) : fieldName;
              if(fieldName) {
                if (fieldNameAcrossViews.indexOf(fieldName) != -1 && (!control.copiedFrom)) {
                  var labelField = label ? label : fieldName;
                  message.push('Duplicate Field Name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
                //ignore this validation if app status sync and closed date sync are enabled
                if (!syncappstatus && !synccloseddate && (fieldName.startsWith("DS_") || fieldName.startsWith("DSI_")) && !control.forceToReadOnly && !control.readOnly) {
                  message.push('"DS_" OR "DSI_" not allowed in field name ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
                fieldNames.push(fieldName);
                (!control.copiedFrom) && fieldNameAcrossViews.push(fieldName);
                if (!this.Util.isValidXMLTagName(fieldName)) {
                  message.push('Field Name is not valid. ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
                if (protectedParams.indexOf(fieldName.toLowerCase()) > -1) {
                  let labelfield = label ? label : fieldName;
                  message.push('System reserved keyword used as field name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
              }
              if(control.properties.Basic && control.properties.Basic['Field Name'] && !control.properties.Basic['Field Name'].selectedValue) {
                !fieldName && message.push('Field Name missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
              }

              let dataFieldName = control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue;
              if(dataFieldName) {
                //ignore this validation if app status sync and closed date sync are enabled
                if (!syncappstatus && !synccloseddate && (dataFieldName.startsWith("DS_") || dataFieldName.startsWith("DSI_")) && !control.forceToReadOnly && !control.readOnly) {
                  message.push('"DS_" OR "DSI_" not allowed in data field name ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
                
                if (!this.Util.isValidXMLTagName(dataFieldName)) {
                  message.push('Data Field Name is not valid. ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }
                
                if (protectedParams.indexOf(dataFieldName.toLowerCase()) > -1) {
                  message.push('System reserved keyword used as data field name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                }

                dataFieldNames.push(dataFieldName);

                controls.forEach((item) => {
                    if(control.type != item.type) {
                        let itemDataFieldName = item.properties.Basic && item.properties.Basic['Data Field Name'] && item.properties.Basic['Data Field Name'].selectedValue;
                        if(dataFieldName && dataFieldName == itemDataFieldName && (_this.typeWiseDataFieldNameAllowed[control.type].indexOf(item.type) == -1)) {
                          let controlLable = item.properties.Basic && (item.properties.Basic.Label || item.properties.Basic.Text) && (item.properties.Basic.Label || item.properties.Basic.Text).selectedValue || '';
                          message.push(`${control.type} data field name is set in "${viewName}" : "${controlLable}". which type is not a ${_this.typeWiseDataFieldNameAllowed[control.type].join(', ')}.<br>`);
                        }
                    }
                });
              }
              
              if(control.properties.Basic && control.properties.Basic['Data Field Name'] && !control.properties.Basic['Data Field Name'].selectedValue) {
                !dataFieldName && message.push('Data Field Name missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
              }

              if(control.properties.Basic && control.properties.Basic.ControlType =='Hyperlink' && ((control.properties.Basic['DisplayLabel'] && control.properties.Basic['DisplayLabel'].selectedValue == '') ||
                (control.properties.Basic['Value'] && control.properties.Basic['Value'].selectedValue == ''))) {
                  message.push('Link Address/Display Label is missing in ' + viewName +  ': ' + labelAndFieldName + ' <br>');
              }

              if(control.properties.Basic && control.properties.Basic.ControlType =='ToggleButton' && ((control.properties.Basic['ValueOn'] && control.properties.Basic['ValueOn'].selectedValue == '') ||
                (control.properties.Basic['ValueOff'] && control.properties.Basic['ValueOff'].selectedValue == ''))) {
                  message.push('Value On/Value Off is missing in ' + viewName +  ': ' + labelAndFieldName + ' <br>');
              }
              if (control.type == 'ViewAssociations' && control.properties.Basic && (!control.properties.Basic['Assoc Type'].selectedValue || !control.properties.Basic['Message Type'].selectedValue)) {
                message.push('Assoc Type/Message Type missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
              }
              
            }
            let list = [];
            switch (control.type) {
              case 'Dropdown':
                let staticData = _.get(control.properties, '["Data Source"].Source.selectedValue');
                if (staticData == '3') {
                  list = _.get(control.properties, '["Data Source"].table.list');
                  if (list.length) {
                    let withOutVal = list.filter(function (val) {
                      return (val.Label.name == '' || val.Value.name == '');
                    });
                    if (withOutVal.length) {
                      message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                    }
                  }
                }
                break;
                case 'MultiDropdown':
                  let mstaticData = _.get(control.properties, '["Data Source"].Source.selectedValue');
                  if (mstaticData == '3') {
                    list = _.get(control.properties, '["Data Source"].table.list');
                    if (list.length) {
                      let withOutVal = list.filter(function (val) {
                        return (val.Label.name == '' || val.Value.name == '');
                      });
                      if (withOutVal.length) {
                        message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                      }
                    }
                  }
                  break;
              case 'Radio':
              case 'Checkbox':
                list = _.get(control.properties, '["Data Source"].table.list');
                if (list.length) {
                  let withOutVal = list.filter(function (val) {
                    return (val.Label.name == '' || val.Value.name == '');
                  });
                  if (withOutVal.length) {
                    message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
                  }
                }
                break;
            }
          }

          let self = this;
          allControls = allControls.concat(controls.filter(function (val) {
            val.viewName = view;
            return self.Util.controlsWithoutFieldName.indexOf(val.type) == -1;
          }));

          if (view == "ORI_VIEW" && dataFieldNames.indexOf('ORI_FORMTITLE') == -1) {
            message.push('Form Title missing in ' + viewName + '. Add \'ORI_FORMTITLE\' in Data field name property.');
          }
        } else if (view == "ORI_VIEW") {
          message.push('Form Title missing in ' + viewName + '. Add \'ORI_FORMTITLE\' in Data field name property.');
        }
      }
    }

    message.length && (isValid = false);

    return {
      status: isValid,
      message: message.join(''),
      allControls: allControls
    }
  }

  validateAndSave(callBack, download = false, publish = false) {
    let self = this;
    this.deselectAll(null);
    this.deselectAllOtherViews();
    if (self.config.for == 'Marketplace') {                                                   //  To disable saving of blank forms in Marketplace.
      if (this.views.ORI_VIEW.controls.A.length == 1) {
        this.ngNotification.error({
          message: 'The view is empty with no controls. Please add some content in the form.', positionX: 'center', replaceMessage: true
        });
        return;
      }
    }
    let viewData = angular.copy(this.views);
    let validation = this.validate(viewData);
    this.$scope.save = function () {
      self.save(undefined, validation, viewData);
    }
    if (!validation.status) {
      if (download || validation.hasTwoAutoNumbering) {
        this.ngNotification.error({
          message: validation.message, positionX: 'center', replaceMessage: true
        });
      } else {
        this.ngNotification.warning({
          message: validation.message, positionX: 'center', replaceMessage: true, templateUrl: "validation_template.html", scope: this.$scope
        });
      }
      return;
    }
    if (+self.checkSectionandWeightage().toFixed(2) > 1.00) {
      this.ngNotification.error({
        message: 'Total sections weightage is greater than 1', positionX: 'center', replaceMessage: true
      });
      return;
    }
    this.save(callBack, validation, viewData, publish);
  }

  loadData(data) {
    let self = this;
    self.loading = false;
    self.apiConnections = angular.copy(data.entity);
  }
  apiConnectionClosed (){
    let self = this;
    // this.loading = true;
    let formID = this.params.id || null;
    let projectId = this.params.id.projectId ? this.params.id.projectId : undefined;
    let instanceGroupId = this.params.id.instanceGroupId || this.params.id.instanceGroupId;
    let apiList = self.Util.getAllAPIConnections(formID,instanceGroupId,projectId);
    // let apiConnections = [];
    apiList.then(function (response) {
      self.loadData(response.data)
    }, function (err) {
      console.log(err);
    });
  }

  checkSectionandWeightage() {
    let controls = this.Util.getAllControls();
    let filteredControls = controls.filter(sec => sec.type == 'Section');
    let reviewSections = filteredControls.filter(ctrl => (ctrl.properties.Basic['Field Name'].selectedValue).indexOf('Review_Section') != -1);
    let weightage = 0;
    if (reviewSections.length > 0) {
      for (let i = 0; i < reviewSections.length; i++) {
        let weigthVal = reviewSections[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue;
        weightage = parseFloat(weigthVal) + weightage;
      }
    }
    return weightage;
  }

  save(callBack, validation, viewData, publish = false) {
    let self = this;
    let languageData = angular.copy(this.store.get('Languages'));
    let supportedLanguages = angular.copy(self.Util.supportedLanguages);

    if (!languageData) {
      languageData = { 'Default': {} };
      for (var index = 0; index < supportedLanguages.length; index++) {
        languageData[supportedLanguages[index]['languageId']] = {};
      }
    }

    if (validation.allControls.length) {
      for (var index = 0; index < validation.allControls.length; index++) {
        let element = validation.allControls[index];
        let fieldName = element.uid;
        let value = '';
        if (element.properties.Basic && element.properties.Basic.LabelOn) {
          value = element.properties.Basic.LabelOn.selectedValue;
          !languageData['Default'] && (languageData['Default'] = {});
          languageData['Default'][element.viewName + '_labelon_' + fieldName] = value;
        }
        if (element.properties.Basic && element.properties.Basic.LabelOff) {
          value = element.properties.Basic.LabelOff.selectedValue;
          !languageData['Default'] && (languageData['Default'] = {});
          languageData['Default'][element.viewName + '_labeloff_' + fieldName] = value;

        } 
        if (element.properties.Basic && element.properties.Basic.DisplayLabel) {
          value = element.properties.Basic.DisplayLabel.selectedValue;
          !languageData['Default'] && (languageData['Default'] = {});
          languageData['Default'][element.viewName + '_displayLabel_' + fieldName] = value;

        } 
        if((element.properties.Basic && element.properties.Basic.Label) || (element.properties.Basic && element.properties.Basic.Text)) {
          if (element.properties.Basic && element.properties.Basic.Label) {
            value = element.properties.Basic.Label.selectedValue;
          } else if (element.properties.Basic && element.properties.Basic.Text) {
            value = element.properties.Basic.Text.selectedValue;
          }
          !languageData['Default'] && (languageData['Default'] = {});
          languageData['Default'][element.viewName + '_' + fieldName] = value;
        }
        
      }
    }

    self.processToUpdateReadOnlyControlProperties(true);
    this.store.set('Languages', languageData);
    this.getPrintViewJson(viewData, languageData);
    self.executeGlobleScript();
    self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
    self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
    self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
    self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
    self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
    let data: any = {
      "id": this.params.id,
      "description": this.params.description,
      "formName": this.params.formName,
      "formViewJson": JSON.stringify(viewData),
      "languageData": JSON.stringify(languageData),
      "formScript": JSON.stringify(self.globleScript),
      "counter": angular.toJson(this.counterService.counter),
      "apiConnections": JSON.stringify(self.apiConnections),
      "formProperties": JSON.stringify(self.formProperties)
    };

    let httpParams: any = {
      'url': (<any>window).properties.service.uri + ACTION_IDS.SAVE_DESIGN,
      'method': 'POST',
      'data': data,
      'headers': {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      'withCredentials': true
    }

    if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
      httpParams.url = (<any>window).properties.service.commonApiUrl + ACTION_IDS.SAVE_DESIGN_BY_FORM_TYPE;
      delete data.id;
      delete data.description;
      delete data.formName;
      data.formTypeId = this.params.id.formTypeId || this.params.id.formTypeID;
      data.projectId = this.params.id.projectId;
      httpParams.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      httpParams.transformRequest = function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      }
    }

    this.loading = true;
    this.$http(httpParams).then(response => {
      self.loading = false;
      callBack && callBack();
      let msg=self.$translate.instant('operation.successful');
      !publish && self.ngNotification.success({ message: msg, positionX: 'center', replaceMessage: true });
      self.published = false;
      self.savedChanges = true;
    }, function errorCallback(response) {
      let msg=self.$translate.instant('error.while.processing.request');
      self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
      self.loading = false;
    });
  }

  changeTheme = function (theme) {
    let self = this;
    var formElement = angular.element(document.querySelector(".container-fluid"));
    formElement.removeClass('formdesigner-advanced');
    let bodyElement = angular.element(document.querySelector("body"));
    bodyElement.removeClass('formdesigner-advanced');
    if (theme)
      this.selectedTheme = theme;
    else {
      console.log(this.selectedTheme);
      this.selectedTheme = this.selectedTheme == 1 ? 2 : 1;
    }
    if(self.config.for == 'Marketplace'){
      this.selectedTheme = 1;
    }
    if (this.selectedTheme == this.designStyle.ADVANCED) {
      formElement.addClass('formdesigner-advanced');
      bodyElement.addClass('formdesigner-advanced');
    }
  }

  closeDropdown(event) {
    let activeElement = document.activeElement;
    if (activeElement && activeElement instanceof HTMLElement && activeElement.tagName.toLowerCase() == 'select') {
      activeElement.blur();
    }
  }
  hideColorPicker($event){
    //trigger spectrum cancel to hide the colorpicker on selecting any form element
    angular.element('.spectrum-color-picker-container').not('.sp-hidden').find(".sp-cancel").trigger("click");
  }
  stopPropagation(event) {
    event.stopPropagation()
  }

  goBack() {
    let msg =this.$translate.instant('warning.for.go.back')
    if (!this.savedChanges) {
      this.ngNotification.warning({
        message: msg, positionX: 'center', replaceMessage: true, templateUrl: "warning_before_leave_template.html", scope: this.$scope
      });
    } else {
      this.$scope.goBack();
    }
  }

  openHelpPage() {
    this.$window.open((<any>window).properties.service.helpUrl);
  }

  openELearning() {
    let commonApi = (<any>window).properties.service.commonApiUrl;;        
    this.$window.open(commonApi.replace('commonapi/','') + 'adoddle/view/externalapp/elearning.jsp');
  }

  remove(removeAll) {
    let self = this;
    let selectedItems = [];
    if (removeAll) {
      selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A, [], false, true);
    }
    else {
      selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A);
    }
    selectedItems = selectedItems.filter(function (el) { return el != ""; });

    this.$scope.removeSelectedOrAll = function () {
      self.removeSelectedOrAll();
    };

    if (selectedItems.length > 0) {
      if (removeAll) {
        this.ngNotification.warning({
          message: 'warning.before.remove.all', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_delete_all.html", scope: this.$scope
        });
      }
      else {
        this.ngNotification.warning({
          message: 'warning.before.remove.selected', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_delete_selected.html", scope: this.$scope
        });
      }
    }
    this.selectedControlToRemove = {
      item: selectedItems
    };
  }

  removeSelectedOrAll() {
    let self = this;
    for (const key in this.selectedControlToRemove.item) {
      const element = this.selectedControlToRemove.item[key];
      if (_.get(element, "properties.Basic['Data Field Name'].selectedValue", '') != 'ORI_FORMTITLE') {
        let list = this.selectedView.view.controls.A;
        this.controlToRemove = {
          item: element,
          list: list
        };
        this.removeCopied(null, false);
      }
    }
    self.broadcastDesignChange();
  }

  copy(copyAll) {
    let selectedItems = [];
    if (copyAll) {
      selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A, [], false, true);     
    } 
    else {
      selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A);      
    }
    selectedItems = selectedItems.filter(function (el) {return el != "";});
    
    this.copiedItems = angular.copy(selectedItems);
    this.ngNotification.success({ message: selectedItems.length + (selectedItems.length <= 1 ? ' item copied.' : ' items copied.'), positionX: 'center', replaceMessage: true });
  }
  paste() {
    let self = this;
    let copiedItems = angular.copy(this.copiedItems);
    for (let i = 0; i < copiedItems.length; i++) {
      let field = copiedItems[i];
      field.selected = false;
      let fieldName = _.get(copiedItems[i], 'properties.Basic["Field Name"].selectedValue', '');
      if (copiedItems[i].uid && copiedItems[i].type == 'ViewAssociations') {
        this.convertToReadOnly(copiedItems[i]);
      }
      if (copiedItems[i].uid && copiedItems[i].type == "RepeatingTable") {
        this.Util.accessRepeatingTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            if(elems[i].type == 'ViewAssociations') {
              self.convertToReadOnly(elems[i]);
            }
          }
        });
        field.copiedFromRepeatingTable = fieldName;
        this.addFlagIfInlineAssocExist(field);
      }
      if (copiedItems[i].uid && (copiedItems[i].type == "Table" || copiedItems[i].type == "Layout")) {
        if(copiedItems[i].type == "Table") {
          this.Util.accessTableElements(field, function (elems) {
            for (let i = 0; i < elems.length; i++) {
              if(elems[i].type == 'ViewAssociations') {
                self.convertToReadOnly(elems[i]);
              }
            }
          });
        }
        if(copiedItems[i].type == "Layout") {
          this.Util.accessLayoutElements(field, function (elems) {
            for (let i = 0; i < elems.length; i++) {
              if(elems[i].type == 'ViewAssociations') {
                self.convertToReadOnly(elems[i]);
              }
            }
          });
        }
        this.addFlagIfInlineAssocExist(field);
      }
      if (copiedItems[i].uid && (copiedItems[i].type == "InlineAssocFiles" || copiedItems[i].type == "InlineAssocApps")) {
        field.copiedFromInlieAssoc = fieldName;
      }
      if (field.parent) {
        delete field.parent;
      }

      if (copiedItems[i].type != 'ViewAssociations') {
        this.updateUid(field);
      }
    }
    if(this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName){
      copiedItems.forEach((copiedItem, i)=>{
        this.selectedItemDomain.splice(this.selectedItemIndex+i+1, 0, copiedItem);
      }, this)
    }else{this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
    }
    this.broadcastDesignChange();
  }

  addFlagIfInlineAssocExist(field) {
    for (let el of field.data) {
      if (el.elems) {
        let inlineControl = el.elems[0][0];
        if (inlineControl && inlineControl.uid && (inlineControl.type == "InlineAssocFiles" || inlineControl.type == "InlineAssocApps")) {
          inlineControl.copiedFromInlieAssoc = _.get(inlineControl, 'properties.Basic["Field Name"].selectedValue', '');
        }
        if (inlineControl && inlineControl.uid && (inlineControl.type == "RepeatingTable" || inlineControl.type == "Table" || inlineControl.type == "Layout")) {
          this.addFlagIfInlineAssocExist(inlineControl);
        }
      } else {
        for (let item of el) {
          let inlineControl = item.elems[0][0];
          if (inlineControl && inlineControl.uid && (inlineControl.type == "InlineAssocFiles" || inlineControl.type == "InlineAssocApps")) {
            inlineControl.copiedFromInlieAssoc = _.get(inlineControl, 'properties.Basic["Field Name"].selectedValue', '');
          }
          if (inlineControl && inlineControl.uid && (inlineControl.type == "RepeatingTable" || inlineControl.type == "Table" || inlineControl.type == "Layout")) {
            this.addFlagIfInlineAssocExist(inlineControl);
          }
        }
      }
    }
  }

  convertToCalculatedField(field, readOnly = false, viewName, languageData) {
    let self = this;
    let fieldName = _.get(field, 'properties.Basic["Field Name"].selectedValue', '');
    if (fieldName !== '') {
      field.pasteAsCalculatedFrom = fieldName;
    }

    if(field.type == 'Attachment' || field.type == 'Image' || field.type == 'Label' || field.type == 'Button' || field.type == 'SiteLocationButton' || field.type == 'Hyperlink' || field.type == 'InlineAssocFiles' || field.type == 'InlineAssocApps' || field.type == 'ViewAssociations') {
      self.convertToReadOnly(field);
      return;
    }
    let readOnlyField = angular.copy(this.models.items.filter(function (val) { return val.type == "Display field" })[0]);
    self.resetsEventLogic(field.properties);

    if(field.parent) {
      delete field.parent;
    }
    
    _.set(field, 'properties.Display.Hidden.selectedValue', false);
    _.set(field, 'properties.Events.Name.hideSection', true);
    let controlFieldName = '';
    switch (field.type) {
      case 'Layout':
        controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
        _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
        _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
        field.uid = self.Util.getGUID();
        self.Util.accessLayoutElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
          }
        });
        break;
      case 'Table':
        controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
        _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
        _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
        field.uid = self.Util.getGUID();
        self.Util.accessTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
          }
        });
        break;
      case 'RepeatingTable':
        let rptFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '');
        controlFieldName = rptFieldName + '_Copy';
        _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
        _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
        _.set(field, 'properties.Basic["Data Field Name"].hidden', true);
        _.set(field, 'properties.Basic.Insert_Button_Text.hidden', true);
        _.set(field, 'properties.Basic.Columns.hidden', true);
        _.set(field, 'properties.Basic.Include_Header.hidden', true);
        _.set(field, 'properties.Basic.Include_Footer.hidden', true);
        _.set(field, 'properties.Basic.Insert_Button_Text.selectedValue', '');
        _.set(field, 'properties.Basic.Value', {
          name: 'value',
          selectedValue: '{{' + rptFieldName + '}}',
          type: 'textbox',
          hidden: true,
          disable: true
        });
        _.set(field, 'properties.Basic.DSName', {
          selectedValue: rptFieldName,
          hidden: true
        });

        field.uid = self.Util.getGUID();
        field.derivedControlType = field.type;
        field.derivedFromFieldName = rptFieldName;
        self.Util.accessRepeatingTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
          }
        });
        break;
      case 'Section':
        controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
        _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
        _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
        field.uid = self.Util.getGUID();
        self.Util.accessSectionElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
          }
        });
        break;
      case 'Line':
        _.set(field, 'properties.Display.Name.hideSection', true);
        field.uid = self.Util.getGUID();
        field.viewName = viewName;
        break;
      case 'Map':
        readOnlyField.mapType = _.get(field, 'properties.Basic.Type.selectedValue', '35');
      default:
        _.set(readOnlyField, 'readOnly', readOnly);
        _.set(readOnlyField, 'autoGenerated', true);
        _.set(readOnlyField, 'properties.Display.Hidden.selectedValue', false);
        _.set(readOnlyField, 'pasteAsCalculated', true);
        _.set(readOnlyField, 'forceToReadOnly', true);
        let fieldName = field.properties.Basic['Field Name'].selectedValue;
        let dataFieldName = field.properties.Basic && field.properties.Basic['Data Field Name'] && field.properties.Basic['Data Field Name'].selectedValue || fieldName;
        if (readOnly) {
          readOnlyField.properties.Basic['Field Name'].selectedValue = fieldName;
          readOnlyField.properties.Basic['Field Name'].prevSelectedValue = fieldName;
          readOnlyField.properties.Basic['Field Name'].disable = true;
          readOnlyField.properties.Basic.Value.disable = true;
          readOnlyField.properties.Basic.Value.addOnButton = '';
        } else {
          var cnt = 0;
          if((field.type.toLowerCase() == "dropdown" && 
            field.properties.Advance["App Status"] && 
            field.properties.Advance["App Status"].selectedValue == true) || 
            field.type == "Datepicker" && 
            field.properties.Advance["Closed Date"] && 
            field.properties.Advance["Closed Date"].selectedValue == true) {
            if(this.counterService.counter) {
              if (this.counterService.counter[field.type] == undefined) {
                this.counterService.counter[field.type] = 0;
              }
              this.counterService.counter[field.type]++;
              cnt = this.counterService.counter[field.type];
            }
            let type = this.Util.replaceAllMatches(field.type, '-', '_');
            readOnlyField.properties.Basic['Field Name'].selectedValue = `${type}${cnt ? ('_' + cnt) : ''}` + '_Copy';
            readOnlyField.properties.Basic['Field Name'].prevSelectedValue = readOnlyField.properties.Basic['Field Name'].selectedValue;
          } else {
            readOnlyField.properties.Basic['Field Name'].selectedValue = fieldName + '_Copy';
            readOnlyField.properties.Basic['Field Name'].prevSelectedValue = readOnlyField.properties.Basic['Field Name'].selectedValue;
          }
          if (field.properties.Basic.DSName && field.properties.Basic.DSName.selectedValue) {
            readOnlyField.properties.Basic.DSName.selectedValue = field.properties.Basic.DSName.selectedValue;
          } else {
            readOnlyField.properties.Basic.DSName.selectedValue = dataFieldName;
          }
        }

        if ((field.type == "Dropdown" || field.type == "MultiDropdown") && field.forceToReadOnly) {
          let sourceType = _.get(field, 'properties["Data Source"].Source.selectedValue', '');
          if (sourceType == 4) {
            let fixedFieldUrl = _.get(field, "properties['Data Source']['fixedFieldUrl'].selectedValue", {});
            if (typeof fixedFieldUrl != 'string') {
              readOnlyField.properties.Basic.DSName.selectedValue = fixedFieldUrl.value;
            }
          }
        }

        if(field.type == "Datepicker") {
          readOnlyField.properties.Basic.RefFieldName = field.properties.Basic['Field Name'].selectedValue;
        }

        readOnlyField.properties.Basic.Value.selectedValue = '{{' + dataFieldName + '}}';
        let label = field.properties.Basic.Label.selectedValue;       
        readOnlyField.properties.Basic.Label.selectedValue = label;
        readOnlyField.uid = self.Util.getGUID();
        readOnlyField.derivedControlType = field.type;
        readOnlyField.derivedFromFieldName = dataFieldName;
        if (field.type == "Dropdown" || field.type == "MultiDropdown") {
          let sourceType = _.get(field, 'properties["Data Source"].Source.selectedValue', '');
          if (sourceType == 5) {
            let customAttr = _.get(field, "properties['Data Source']['customAttr'].selectedValue", '');
            if (customAttr) {
              readOnlyField.derivedFromCA = customAttr;
            }
          }
        }
        this.copyLabels(field.viewName, field.uid, readOnlyField.uid, viewName, languageData);
        if (field.properties.Style && readOnlyField.properties.Style) {
          angular.merge(readOnlyField.properties.Style, field.properties.Style);
        }
        for (let key in field) {
          if (key !== 'pasteAsCalculatedFrom') {
            delete field[key];
          }
        }
        field.viewName = viewName;
        angular.merge(field, readOnlyField);
        break;
    }
  }

  pasteAsReadOnly() {
    let copiedItems = angular.copy(this.copiedItems);
    for (let i = 0; i < copiedItems.length; i++) {
      copiedItems[i].selected = false;
      let field = copiedItems[i];
      let fieldName = _.get(copiedItems[i], 'properties.Basic["Field Name"].selectedValue', '');
      if (copiedItems[i].uid && copiedItems[i].type == "RepeatingTable") {
        this.addFlagIfInlineAssocExist(field);
      }
      if (copiedItems[i].uid && (copiedItems[i].type == "Table" || copiedItems[i].type == "Layout")) {
        this.addFlagIfInlineAssocExist(field);
      }
      if (copiedItems[i].uid && (copiedItems[i].type == "InlineAssocFiles" || copiedItems[i].type == "InlineAssocApps")) {
        field.copiedFromInlieAssoc = fieldName;
      }
      this.convertToReadOnly(copiedItems[i]);
    }
    if(this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName){
      copiedItems.forEach((copiedItem, i)=>{
        this.selectedItemDomain.splice(this.selectedItemIndex+i+1, 0, copiedItem);
      }, this)
    }else{this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
    }
    this.broadcastDesignChange();
    setTimeout(() => {
      for (let i = 0; i < copiedItems.length; i++) {
        let textareaId = copiedItems[i].uid;
        let textele = angular.element("textarea[textarea-id=" + textareaId + "]");
        for (let j = 0; j < textele.length; j++) {
          textele[j].style.height = 35 + 'px'
          textele[j].style.height = textele[j].scrollHeight + 'px'
          textele[j].style.whiteSpace = 'normal';
        }
      }
    }, 100)
  }

  convertToReadOnly(field, isPaste?) {
    let self = this;
    field.forceToReadOnly = true;
    let fieldName = _.get(field, 'properties.Basic["Field Name"].selectedValue', '');
    if (fieldName !== '') {
      field.copiedFrom = fieldName;
    }
    
    if(field.parent) {
      delete field.parent;
    }

    switch (field.type) {
      case 'Layout':
        self.Util.accessLayoutElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToReadOnly(elems[i], isPaste);
          }
        });
        break;
      case 'Table':
        self.Util.accessTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToReadOnly(elems[i], isPaste);
          }
        });
        break;
      case 'RepeatingTable':
        self.Util.accessRepeatingTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToReadOnly(elems[i], isPaste);
          }
        });
        break;
      case 'Section':
        self.Util.accessSectionElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            self.convertToReadOnly(elems[i], isPaste);
          }
        });
        break;
    }

    if(field.type != 'Line') {
      self.Util.markAllPropertiesAsReadonly(field, field.properties);
    }

  }

  resetsEventLogic(properties) {
    let eventsDetail = _.get(properties, 'Events', {});
    for(let event in eventsDetail) {
      if(event != 'Name' && event != 'forceToDisabled') {
        eventsDetail[event].selectedValueReadonly = eventsDetail[event].selectedValue;
        eventsDetail[event].disable = true;
        eventsDetail[event].selectedValue = '';
      }
    }
  }

  pasteAsCalculatedField() {
    let copiedItems = angular.copy(this.copiedItems);
    let viewName = this.selectedView.view.viewName || '';
    for (let i = 0; i < copiedItems.length; i++) {
      copiedItems[i].selected = false;
      this.convertToCalculatedField(copiedItems[i], undefined, viewName, undefined);
    }
    if(this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName){
      copiedItems.forEach((copiedItem, i)=>{
        this.selectedItemDomain.splice(this.selectedItemIndex+i+1, 0, copiedItem);
      }, this)
    }else{this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
    }
    this.broadcastDesignChange();
  }

  maximizedCodeEditor: boolean = false;

  /**
   * @brief      Open model dialog which contains code editor as body content
   *
   * @return     null
   */
  openCodeEditorDialog() {
    let self = this;
    let codeEditorModalInstance = self.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'globleCodeEditor.html',
      backdrop: 'static',
      keyboard: false,
      controllerAs: '$ctrl',
      windowClass: 'code-editor-modal',
      appendTo: angular.element(self.$document[0].querySelector('.canvas')),
      controller: function () {
        this.maximized = false;
        this.showSpinner = true;
        self.maximizedCodeEditor = false;
        angular.element(window).on('resize', () => {
          self.codeEditorResizeHandler();
        });
        let globleMethodsDetails = {};
        window.setTimeout(() => {
            self.codeEditorResizeHandler();
            self.codeEditor = angular.element(self.$document[0].querySelector('#globleBlocklyCodeEditor')).data('$asiteBlocklyController');
            self.codeEditor.setVal(self.globleScript.xmlVal);
            globleMethodsDetails = self.codeEditor.getGlobleMethodsDetail();
        }, 10);
        
        document.body.style.overflow = 'hidden';

        this.isPasteDisabled = function() {
          if(self.$window.localStorage.getItem('domXml')) {
            return false;
          }
          return true;
        }

        this.pasteGlobalBlockly = function(){
          try {
            self.codeEditor = angular.element(self.$document[0].querySelector('#globleBlocklyCodeEditor')).data('$asiteBlocklyController');
            let newDomBlock = self.Util.getBlocklyBlock();
            self.codeEditor.setVal(newDomBlock);
          } catch(error) {
            self.ngNotification.error({ message: error.message.split('and')[0], positionX: 'center', replaceMessage: true });
          }
        }

        this.save = function () {
          //Read and Validate value from Blockly Eitor and save it
          self.globleScript = self.codeEditor.getVal(true);
          if(self.globleScript && self.globleScript.isAPIInProgress) {
            self.ngNotification.error({ message: 'API call is in progress ', positionX: 'center', replaceMessage: true });
            return;
          }
          self.executeGlobleScript();
          self.replaceUpdatedGlobleMethodName(globleMethodsDetails, self.codeEditor.getGlobleMethodsDetail())
          codeEditorModalInstance.close();
          self.destroyCodeEditor();
        };

        /**
         * @brief      Close dialog
         * @return     NULL
         */
        this.cancel = function () {
          // codeEditorModalInstance.dismiss('cancel');
          codeEditorModalInstance.close(false);
          self.destroyCodeEditor();
        };

        this.maximize = () => {
          this.maximized = true;
          self.maximizedCodeEditor = true;
          self.codeEditorResizeHandler();
        };

        this.minimize = () => {
          this.maximized = false;
          self.maximizedCodeEditor = false;
          self.codeEditorResizeHandler();
        };
      }
    });
  }

  replaceUpdatedGlobleMethodName(oldMethods, newMethods) {
    for(let methodId in oldMethods) {
      if(newMethods[methodId] != oldMethods[methodId]) {
        let controls = this.Util.getAllControls();
        
        //Replace in controls events code editor
        controls.forEach((control) => {
          if(control.properties && control.properties.Events) {
            for(let event in control.properties.Events) {
              let eventDetail = control.properties.Events[event];
              if(event != 'Name' && eventDetail.selectedValue) {
                if(newMethods[methodId]) {
                  eventDetail.xmlValue = this.Util.replaceAllMatches(eventDetail.xmlValue, '"fn_'+ oldMethods[methodId]+'"', '"fn_'+ newMethods[methodId]+'"');
                  eventDetail.xmlValue = this.Util.replaceAllMatches(eventDetail.xmlValue, ">"+ oldMethods[methodId]+"<", ">"+ newMethods[methodId]+"<");
                  let oldVal = oldMethods[methodId].replace(/ /g, "_");
                  let newVal = newMethods[methodId].replace(/ /g, "_");
                  eventDetail.selectedValue = this.Util.replaceAllMatches(eventDetail.selectedValue, '(' + oldVal + ' && ' + oldVal + '())', '(' + newVal + ' && ' + newVal + '())');
                }else{
                  eventDetail.xmlValue = this.Util.replaceAllMatches(eventDetail.xmlValue, '"fn_'+ oldMethods[methodId]+'"', '"fn_noopMethod"');
                  eventDetail.xmlValue = this.Util.replaceAllMatches(eventDetail.xmlValue, ">"+ oldMethods[methodId]+"<", ">noopMethod<");
                  let oldVal = oldMethods[methodId].replace(/ /g, "_");
                  eventDetail.selectedValue = this.Util.replaceAllMatches(eventDetail.selectedValue, '(' + oldVal + ' && ' + oldVal + '());', '');
                }
              }
            }
          }
        });
      }
    }
  }

  codeEditorResizeHandler() {
    let width = (this.maximizedCodeEditor) ? window.innerWidth : Math.min(1280, window.innerWidth);
    let height = (this.maximizedCodeEditor) ? window.innerHeight : Math.min(600, window.innerHeight);
    let margin = (this.maximizedCodeEditor) ? 10 : (width <= 768) ? 10 : 30;
    angular.element('.canvas .code-editor-modal .modal-dialog').css({
      'width': (width - (margin * 2)) + 'px',
      'height': (height - (margin * 2)) + 'px',
      'marginTop': margin + 'px',
      'marginBottom': margin + 'px'
    });
  }
  
  /**
   * @brief      Destroy existing code editer intanceview.
   *
   * @return     null
   */
  destroyCodeEditor() {
    let self = this;
    document.body.style.overflow = '';
    self.codeEditor.destroyCodeEditor();
    self.codeEditor = undefined;
    angular.element(window).off('resize');
  }

  updateUid(field) {
    let self = this,childElems = [];
    let viewName = this.selectedView.view.viewName || '';
    let newUid = self.Util.getGUID();
        
    switch (field.type) {
      case 'Layout':
        self.Util.accessLayoutElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            if (elems[i].type != 'ViewAssociations') {
              self.updateUid(elems[i]);
            }
          }
        });

        if(field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
          field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
          field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
          this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
        }
        field.uid = newUid;
        field.viewName = viewName;
        break;
      case 'Table':
        self.Util.accessTableElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            if (elems[i].type != 'ViewAssociations') {
              self.updateUid(elems[i]);
            }
          }
        });

        if(field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
          field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
          field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
          this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
        }
        field.uid = newUid;
        field.viewName = viewName;
        break;
      case 'RepeatingTable':
        childElems = [];
        self.Util.accessRepeatingTableElements(field, function (elems) {          
          for (let i = 0; i < elems.length; i++) {
            if (elems[i].type != 'ViewAssociations') {
              self.updateUid(elems[i]);
            }
            if(childElems.indexOf(elems[i]) == -1) childElems.push(elems[i])
          }
        });
        this.updateCalUidAry(childElems);
        field.copiedFromRepeatingTable = field.properties.Basic['Field Name'].selectedValue;
        if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
          field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
          field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
          this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
        }
        field.uid = newUid;
        field.viewName = viewName;
        break;
      case 'Section':
        self.Util.accessSectionElements(field, function (elems) {
          for (let i = 0; i < elems.length; i++) {
            if (elems[i].type != 'ViewAssociations') {
              self.updateUid(elems[i]);
            }
          }
        });

        if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
          field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
          field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
          this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
        }
        field.uid = newUid;
        field.viewName = viewName;
        break;
      default:
      if (self.Util.controlsWithoutFieldName.indexOf(field.type) == -1) {
        field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
        field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
        this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
      }
      if(field.parent && field.type.toLowerCase() == "display field" && field.properties["Basic"]["DSName"].selectedValue == "calculated"){
        field.properties["Basic"].Value.selectedValue = field.properties["Basic"].Value.selectedValue.replace(/\}/g,"_Copy}"); 
        field.properties["Basic"].formula.html = field.properties["Basic"].formula.html.replace(/\}/g,"_Copy}"); 
        field.properties["Basic"]["DSName"].selectedValue = "calculated"
      }
      field.uid = newUid;
      field.viewName = viewName;
      break;
    }
   
  }
  updateCalUidAry(childElems){
    if(childElems.length){
      let calcField,existingUidAry,UidArry=[];
      for(let c=0;c<childElems.length;c++){
        calcField = childElems[c];
        if(calcField.type == "Display field" && calcField.properties["Basic"]["DSName"].selectedValue == "calculated"){
        
          let splitAry = calcField.properties["Basic"].Value.selectedValue.split(" "),fieldCount=0;
          for(let i=0;i<splitAry.length;i++){
            if(!parseFloat(splitAry[i])){
              fieldCount+=1;
              let str = angular.element.trim(splitAry[i].replace("sum(","").replace(")","").replace("{","").replace("}",""));              
                childElems.forEach(elem =>{
                  if((elem.type == "Textbox" || elem.type == "Display field") && elem.properties.Basic["Field Name"].selectedValue == str){
                      if(UidArry.indexOf(elem.uid) == -1)
                      UidArry.push(elem.uid);
                  }
                });              
            }
          }
          calcField.properties["Basic"].formula.uids = UidArry;
        }
      }
    }
  }
  copyLabels(refViewName, refUid, newUid, selectedViewName, selectedLanguageData) {
    let viewName = selectedViewName || this.selectedView.view.viewName;
    let languageData = selectedLanguageData || this.store.get('Languages');
    let supportedLanguages = angular.copy(this.Util.supportedLanguages);
    if (!languageData) {
      languageData = {};
      for (var index = 0; index < supportedLanguages.length; index++) {
        languageData[supportedLanguages[index]['languageId']] = {};
      }
    }
    for (let language in languageData) {
      if (languageData[language][refViewName + '_' + refUid]) {
        languageData[language][viewName + '_' + newUid] = languageData[language][refViewName + '_' + refUid];
      }

      if(languageData[language][refViewName + '_InlineAssoc_' + refUid]){
        languageData[language][viewName + '_InlineAssoc_' + newUid] = languageData[language][refViewName + '_InlineAssoc_' + refUid];
      }
    }
    !selectedLanguageData && this.store.set('Languages', languageData);
  }

  prepareJsonForHierarchy(allAttr) {
    allAttr = this.Util.getIteams(allAttr);
    for (var index = 0, hierarchyArray = ["Dropdown", "Checkbox","MultiDropdown"]; index < allAttr.length; index++) {
      var parentAttr = allAttr[index];
      if (hierarchyArray.indexOf(parentAttr.type) > -1) {
        var currentElement = parentAttr.properties.Basic["Field Name"].selectedValue;
        this.filterOption.objAttrList[currentElement] = parentAttr;
        this.filterOption.objRelationList[currentElement] = {};
        this.filterOption.resetOption[currentElement] = [];
        var parentList = parentAttr.properties['Data Source'].table.list;
        for (var cindex = 0; cindex < parentList.length; cindex++) {
          if (parentList[cindex]) {
            var currentRelation = parentList[cindex].relation || {};
            for (var key in currentRelation) {
              if (currentRelation.hasOwnProperty(key) && this.filterOption.resetOption[currentElement].indexOf(key) < 0) {
                this.filterOption.resetOption[currentElement].push(key);
              }
              this.filterOption.objRelationList[currentElement][parentList[cindex].Value.name] = currentRelation;
            }
          }
        }
      }
    }
    this.onloadFilteroption(this.filterOption.objAttrList);
  }


  onloadFilteroption(objAttr) {
    for (var key in objAttr) {
      if (objAttr[key].type == "Dropdown" || objAttr[key].type == "MultiDropdown") {
        this.setDropDownOption(objAttr[key]);
      } else {
        this.setCheckBoxOption(objAttr[key]);
      }
    }
  }
  getDropDownHeight(item) {
    var dh = 'auto',
      list = item.properties["Data Source"].table.list.length;

    if (this.external && (list > this.multiHeight)) {
      dh = this.multiHeight * (this.multiHeight * 2) + 'px';
    }

    return angular.merge(this.getIndividualStyleObj(item.properties, 'ControlStyle'), {
      'min-height': dh
    });
  }

  getRadioCheckboxWidth(item) {
    var columnsCount = 1;
    var columnWidth = '100%';
    if (item.properties['Basic']['Number']) {
      columnsCount = item.properties['Basic']['Number'].selectedValue;
      columnWidth = (100 / columnsCount) + '%';
    }
    return columnWidth;
  }
  getHeightWidthOfToggleSwitch(item) {
    let switchHeight = _.get(item, "properties.Size.Height.selectedValue", 25);
    return {
      'width': (switchHeight -2)+ 'px',
      'height': (switchHeight -2)+ 'px',
    }
  }

  linkModelFunc(event,url) {
    event.preventDefault();
    this.$window.open(url);
  }

  setDropDownOption(parentAttr) {
    var attrName = parentAttr.properties.Basic["Field Name"].selectedValue;
    this.resetElement(attrName);
    if (this.filterOption.objRelationList[attrName] && parentAttr.properties.Basic.Value) {
      var selectedValue = [];
      if (angular.isArray(parentAttr.properties.Basic.Value.selectedValue)) {
        selectedValue = parentAttr.properties.Basic.Value.selectedValue;
      } else {
        selectedValue.push(parentAttr.properties.Basic.Value.selectedValue);
      }
      for (var index = 0, pcRelation; index < selectedValue.length; index++) {
        pcRelation = this.filterOption.objRelationList[attrName][selectedValue[index]] || {};
        if (Object.keys(pcRelation).length == 0) {
          this.resetElement(attrName);
          break;
        } else {
          for (var key in pcRelation) {
            if (!this.filterOption.filterList[key]) {
              this.filterOption.filterList[key] = [];
            }
            for (var i = 0; i < pcRelation[key].length; i++) {
              this.filterOption.filterList[key].push(pcRelation[key][i]);
            }
          }
        }
      }
    }
  }

  setCheckBoxOption(parentAttr) {
    var attrName = parentAttr.properties.Basic["Field Name"].selectedValue;
    this.resetElement(attrName);
    if (this.filterOption.objRelationList[attrName]) {
      var selectedValue = [];
      for (var index = 0, list = parentAttr.properties["Data Source"].table.list; index < list.length; index++) {
        if (list[index].selectedValue.name) {
          selectedValue.push(list[index].Value.name);
        }
      }
      for (var index = 0, pcRelation; index < selectedValue.length; index++) {
        pcRelation = this.filterOption.objRelationList[attrName][selectedValue[index]] || {};
        if (Object.keys(pcRelation).length == 0) {
          this.resetElement(attrName);
          break;
        } else {
          for (var key in pcRelation) {
            if (!this.filterOption.filterList[key]) {
              this.filterOption.filterList[key] = [];
            }
            for (var i = 0; i < pcRelation[key].length; i++) {
              this.filterOption.filterList[key].push(pcRelation[key][i]);
            }
          }
        }
      }
    }
  }

  resetElement(attrName) {
    var pcRelation = this.filterOption.resetOption[attrName] || [];
    for (var index = 0; index < pcRelation.length; index++) {
      this.filterOption.filterList[pcRelation[index]] = [];
    }
  }

  filterElementOption(parentAttr, list) {
    if (list.id && this.filterOption.filterList && Object.keys(this.filterOption.filterList).length > 0) {
      var filterList = this.filterOption.filterList[parentAttr.properties.Basic["Field Name"].selectedValue] || [];
      if (filterList.length > 0 && filterList.indexOf(list.id) < 0) {
        if (parentAttr.type == "Checkbox") {
          list.selectedValue.name = false;
        }
        return true;
      } else {
        return false;
      }
    }
  }

  hasScriptLogic(events) {
    if(!events) {
      return false;
    }

    let scriptLogic = false;
    for(let event in events) {
      if(!scriptLogic && event != 'Name' && event != 'forceToDisabled' && (events[event].selectedValue || events[event].selectedValueReadonly)) {
        scriptLogic = true;
      }
    }
    return scriptLogic;
  }
  getDatePickerOptions(properties){
    properties.Basic['Display Format'].selectedValue = this.getDisplayFormat(properties);
    let dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties.Basic['Display Format'].selectedValue;
    if(properties.Basic['Time'] && properties.Basic['Time'].selectedValue)  {
        dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
    }
   this.datePickerOptions.format = dateTimeFormat;
   return this.datePickerOptions;
  }

  getDisplayFormat(properties) {
    try {
      let oldOptionsArr = this.oldformatOptions;
      let selectedObj, newDisplayFormat = properties.Basic['Display Format'].selectedValue;
      if(newDisplayFormat != 'default') {
        for (let i = 0; i < oldOptionsArr.length; i++) {
          if ((properties.Basic['Display Format'].selectedValue) == oldOptionsArr[i].value) {
            selectedObj = oldOptionsArr[i];
            break;
          }
        }

        if(selectedObj) {
          for (let j = 0; j < properties.Basic['Display Format'].options.length; j++) {
            if (selectedObj.key == properties.Basic['Display Format'].options[j].key) {
              newDisplayFormat = properties.Basic['Display Format'].options[j].value;
            }
          }
        }
      }
      return newDisplayFormat;
    } catch(e) {
      return properties.Basic['Display Format'].selectedValue;
    }
  }

  getParsedDate(properties) {
    let dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties.Basic['Display Format'].selectedValue;
    if (properties.Basic['Time'] && properties.Basic['Time'].selectedValue) {
      dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm'
    }
    let itemVal = properties.Basic['Default'].selectedValue;
    itemVal = moment(itemVal, dateTimeFormat).toDate();
    if (itemVal != 'Invalid Date') {
      properties.Basic['Default'].dateObj = moment(itemVal, dateTimeFormat).toDate();
    } else if (properties.Basic['Default'].selectedValue == '' || properties.Basic['Default'].selectedValue == undefined) {
      properties.Basic['Default'].dateObj = '';
    }
  }
  showDatepicker($event) {
    var myElem =  angular.element($event.currentTarget.previousElementSibling);
    if(myElem.length > 0)
    myElem.datetimepicker('show');
  }
  checkValidInput(event, item) {
    if (event.currentTarget) {
      if (event.currentTarget.className.indexOf('ng-invalid') != -1) {
        item.properties.Basic.Default.selectedValue = null;
      }
    }
  }

  checkValidInputDate(event, properties) {
    let dateTimeFormat =  properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') :  properties.Basic['Display Format'].selectedValue;
    if( properties.Basic['Time'] &&  properties.Basic['Time'].selectedValue)  {
        dateTimeFormat =  properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat+' hh:mm A' : dateTimeFormat+' HH:mm'
    }
    let itemVal =  properties.Basic['Default'].selectedValue;
    itemVal = new Date(itemVal);
    if (itemVal == 'Invalid Date') {
        if(  properties.Basic['Default']['dateObj']){
           properties.Basic['Default'].selectedValue = moment(  properties.Basic['Default']['dateObj']).format(dateTimeFormat);
        } else {
           properties.Basic['Default'].selectedValue = '';
        }
    } else if(itemVal != 'Invalid Date' &&   properties.Basic['Default']['dateObj']) {
       properties.Basic['Default'].selectedValue = moment( properties.Basic['Default']['dateObj']).format(dateTimeFormat);
    }
  }

  updatePickerDisplay(event, item) {
    event.preventDefault();
    var dateElemPicker =  angular.element(event.currentTarget);
    dateElemPicker.data("DateTimePicker").keyBinds({'t': null});
    var dateobj = item.properties['Basic']['Default'].dateObj;
    var curFormat = dateElemPicker.data("DateTimePicker").options().format;
    if(dateobj) {
      if((item.properties['Basic']['Default'].selectedValue && item.properties['Basic']['Default'].selectedValue.length) == curFormat.length) {
         dateElemPicker.data('DateTimePicker').date(dateobj);
      }
    }
  }

  setTimeFormat (item) {
    let timeFormat = item.properties['Basic']['Time Format'].selectedValue == 'true' ? 'hh:mm a' : 'HH:mm';
    item.timeFormat = timeFormat;
  }

  getRows(properties) {
    let columnsCount = properties['Basic']['Number'] ? properties['Basic']['Number'].selectedValue : 1;
    if(columnsCount <= 0) columnsCount = 1;
    let rowsCount = properties['Data Source'].table.list.length;
    rowsCount = Math.ceil(rowsCount/columnsCount);
    return rowsCount;
  }

  getListItems(item,properties) {
    let selectedItem = item;
    let columnCount = properties['Basic']['Number'] ? properties['Basic']['Number'].selectedValue : 1;
    if(columnCount <= 0) columnCount = 1;
      let rows = this.getRows(properties);
      let items = [];
      for(let i = 0; i < rows; i++) {
          let rowItems = [];
          for(let j = 0; j < columnCount; j++) {
            if(properties['Data Source'].table.list[j+ (i*columnCount)]) {
              rowItems.push(properties['Data Source'].table.list[j+ (i*columnCount)]);
            }
          }
          items.push(rowItems);
      }
      selectedItem.optionsList = items;
  }
  getTimePickerOptions (properties) {
    this.timePickerOptions.showMeridian = properties['Basic']['Time Format'].selectedValue;
    return this.timePickerOptions;
  }

  getTimeFormat (properties) {
    this.timeFormat = properties['Basic']['Time Format'].selectedValue == true ? 'hh:MM A' : 'HH:mm';
    return this.timeFormat;
  }

  getIndividualStyleObj(properties, item): any {
    if (!properties.ControlStyle && !properties['InsertButtonStyle']) {
      return {};
    }
    return this.getStyleObject(properties, item);
    
  }

  getStyleObject(properties, item){
    let props = properties[item];let readOnlyField = false;;
    if (properties.Display['Read-only']) {
        readOnlyField = properties.Display['Read-only'].selectedValue;
    }

    let styleProperties = angular.merge({}, props['font-style-group'], props['style-group'], props['border-style-group']);
    let styleObject = {
      'font-family': _.get(styleProperties.members, "['font-family']['selectedValue']", 'initial'),
      'font-size': _.get(styleProperties.members, "['font-size']['selectedValue']", '16') + 'px',
      'font-weight': _.get(styleProperties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
      'font-style': _.get(styleProperties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
      'text-decoration': _.get(styleProperties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
      'text-align-last': _.get(styleProperties.members, "['alignment']['selectedValue']", 'left'),
      'text-align': _.get(styleProperties.members, "['alignment']['selectedValue']", 'left'),
      'color': _.get(styleProperties.members, "['font-color']['selectedValue']", 'black'),
      'pointer-events' : readOnlyField ? 'none' : 'auto'
    }
    if((properties['Basic']['ControlType'] == 'Radio' || properties['Basic']['ControlType'] == 'Checkbox') && item == 'ControlStyle') {
      styleObject['text-align-last'] = 'left';
      styleObject['text-align'] = 'left';
      styleObject['justify-content'] = _.get(styleProperties.members, "['alignment']['selectedValue']", 'left')
    }
    if ((properties['Basic']['ControlType'] == 'InlineAssocFiles') || (properties['Basic']['ControlType'] == 'InlineAssocApps')) {
      styleObject['background-color'] = _.get(styleProperties.members, "['background-color']['selectedValue']", 'white');
    }
    return styleObject;
  }

  getButtonStyle(properties, item){
    let styleObj = this.getStyleObject(properties, item);
    styleObj['background-color'] =  _.get(properties.Style['font-style-group'].members, "['background-color']['selectedValue']", 'white');
    styleObj['height'] = _.get(properties.Size, "Height.selectedValue", 'auto');
    styleObj['width'] = _.get(properties.Size, "Width.selectedValue", 'auto');
    return styleObj;
  }

  getStyleObect(item): any {
    if (!item.properties.Style) {
      return {};
    }
    let control=item.type;
    let props = item.properties.Style;
    let marginProps = item.properties.Margin;
    let properties = angular.merge({}, props['font-style-group'], props['style-group'], props['border-style-group']);

    if (item.type == "Button" || item.type == "SiteLocationButton") {
      let styleObj = {
        'padding': '5px'
      }
      return styleObj;
    }
    /*
     * Apply Style for individual cell for TABLE
     */
    if (item.ids || item.properties.ControlStyle) {
      item.ids && this.applyCellStyle(item);
      return {
        'background-color': _.get(properties.members, "['background-color']['selectedValue']", 'white'),
        'padding-top': _.get(marginProps, "['margin-top']['selectedValue']", 0) + 'px',
        'padding-bottom': _.get(marginProps, "['margin-bottom']['selectedValue']", 0) + 'px',
        'padding-right': _.get(marginProps, "['margin-right']['selectedValue']", 5) + 'px',
        'padding-left': _.get(marginProps, "['margin-left']['selectedValue']", 5) + 'px'
      };
    }

    let styleObj = {
      'font-family': _.get(properties.members, "['font-family']['selectedValue']", 'initial'),
      'font-size': _.get(properties.members, "['font-size']['selectedValue']", '16') + 'px',
      'background-color': _.get(properties.members, "['background-color']['selectedValue']", 'white'),
      'font-weight': _.get(properties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
      'font-style': _.get(properties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
      'text-decoration': _.get(properties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
      'text-align-last': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
      'text-align': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
      'color': _.get(properties.members, "['font-color']['selectedValue']", 'black'),
      'padding-top': _.get(marginProps, "['margin-top']['selectedValue']", 0) + 'px',
      'padding-bottom': _.get(marginProps, "['margin-bottom']['selectedValue']", 0) + 'px',
      'padding-right': _.get(marginProps, "['margin-right']['selectedValue']", 5) + 'px',
      'padding-left': _.get(marginProps, "['margin-left']['selectedValue']", 5) + 'px'
    }
    
    if (control=="Button"){
       delete styleObj['background-color'];
     }

    return styleObj;
  }

  applyCellStyle(item) {
    let row, col;
    let props = item.properties.Style;
    let properties = angular.merge({}, props['font-style-group'], props['style-group']);
    for (let i = 0; i < item.ids.length; ++i) {
      if(item.ids[i]) {
        row = parseInt(item.ids[i].split("-")[0], 10);
        col = parseInt(item.ids[i].split("-")[1], 10);

        let control;
        if(item.type == "Layout") {
          control = item.data[col];
        }else {
          control = item.data[row][col];
        }
  
        if(control) {
          control.style = {
            'font-family': _.get(properties.members, "['font-family']['selectedValue']", 'initial'),
            'font-size': _.get(properties.members, "['font-size']['selectedValue']", '16') + 'px',
            'background-color': control.style && control.style['background-color'] ? control.style['background-color'] : 'rgba(255, 255, 255, 0)',
            'font-weight': _.get(properties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
            'font-style': _.get(properties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
            'text-decoration': _.get(properties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
            'text-align-last': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
            'text-align': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
            'color': _.get(properties.members, "['font-color']['selectedValue']", 'black')
          }
        }
      }
    }
  }

  getTableCss(item) {
    return {
      'table-layout': Object.keys(item.width).length > 0 ? 'auto' : 'fixed',
      'margin': '0px'
    }
  }

  getAssociationBorderStyle(item) {
    return {
          'border-width': item.properties.Borders['border-style-group'].members['border-width'].selectedValue + 'px',
          'border-color': item.properties.Borders['border-style-group'].members['border-color'].selectedValue,
        };
  }

  getAssociationTableCss(item) {
    return {
      'table-layout' : 'fixed',
      'margin': '0px',
      'font-family':item.properties.ControlStyle['font-style-group'].members['font-family'].selectedValue,
      'font-size':item.properties.ControlStyle['font-style-group'].members['font-size'].selectedValue,
    }
  }

  getBorderStyleObect(item, extraStyle, width = 'auto'): any {
    if(item.type == "Layout") {
      let styleObj = {
        'border': item.properties.Display.Border.selectedValue,
        width: width
      }
      return angular.merge({}, styleObj, extraStyle);
    }

    if (!item.properties.Borders) {
      return {
        width: width
      };
    }
    let props = item.properties.Borders;
    let properties = angular.merge({}, props['border-style-group'], props['style-group']);
    return angular.merge({}, {
      'border-color': _.get(properties.members, "['border-color']['selectedValue']", 'black'),
      'border-width': _.get(properties.members, "['border-width']['selectedValue']", 0),
      width: width
    }, extraStyle);
  }

  getRepeatingTableBorderStyle(item) {
    if (item.properties.Borders) {
      let properties = item.properties.Borders['border-style-group'];
      return {
        'border-color': _.get(properties.members, "['border-color']['selectedValue']", 'black'),
        'border-width': _.get(properties.members, "['border-width']['selectedValue']", 0)
      };
    }
  }

  ensureGoogleMapsLoaded(): Promise<void> {

    if (this.maps) {
      return Promise.resolve();
    }

    if (this._googleMapsLoadPromise) {
      return this._googleMapsLoadPromise;
    }

    this._googleMapsLoadPromise = this.$http({
      method: 'GET',
      url: (<any>window).properties.service.commonApiUrl + 'vault/secret?key=googleMapGeocoderUrlKey',
      withCredentials: true
    }).then((response) => {
      let apiKey = response.data;

      if (!apiKey) {
        throw new Error('Google Maps API key not found');
      }

      return new Promise<void>((resolve, reject) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places';
        script.onload = () => {
          this.maps = (<any>window).google.maps;
          this.geoCoder = new this.maps.Geocoder();
          resolve();
        };
        script.onerror = () => {
          this._googleMapsLoadPromise = null;
          reject(new Error('Failed to load Google Maps script'));
        };
        document.body.appendChild(script);
      });
    }).catch((err) => {
      this._googleMapsLoadPromise = null;
      throw err;
    });
    return this._googleMapsLoadPromise;
  }

  openMap(properties, uid) {
    this.ensureGoogleMapsLoaded().then(() => {
    let type = _.get(properties, 'Type.selectedValue', '35');
    let selectedValue = _.get(properties, 'Default.selectedValue', '');
    let self = this, lat: any = '', long: any = '', osGridRef = '', marker;
    let forMetaData = self.config.for == "Meta-Data";

    if (type == '36') {
      if (selectedValue.indexOf(' (') != -1) {
        osGridRef = selectedValue.split(' (')[1].split(')')[0];
      } else {
        osGridRef = selectedValue;
      }
      if (osGridRef) {
        let latlong = self.convertGridRef(osGridRef);
        lat = latlong.lat;
        long = latlong.long;
      }
    } else {
      if (selectedValue.indexOf(' (') != -1) {
        let latlangstr = selectedValue.split(' (')[1].split(')')[0];
        lat = parseFloat(latlangstr.split(', ')[0]) || '';
        long = parseFloat(latlangstr.split(', ')[1]) || '';
      } else {
        lat = parseFloat(selectedValue.split(', ')[0]);
        long = parseFloat(selectedValue.split(', ')[1]);
      }
    }

    let clearMarker = function () {
      if (marker && marker.setMap) {
        marker.setMap(null);
      }
      lat = '';
      long = '';
      osGridRef = '';
    }

    let getAddress = function (latitude, longitude, callback) {
      var latlng = {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
      };
      self.geoCoder.geocode({
        'location': latlng
      }, function (results, status) {
        let address = '';
        if (status === 'OK') {
          if (results[0]) {
            address = results[0].formatted_address;
          }
        }
        callback && callback(address);
      });
    }

    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'map-popup.html',
      backdrop: 'static',
      keyboard: false,
      controllerAs: '$ctrl',
      appendTo: angular.element(self.$document[0].querySelector('.canvas')),
      controller: function () {
        let ctrl = this;
        this.clearMarker = clearMarker;
        this.save = function () {
          let address = getAddress(lat, long, function (address) {
            if (address && !forMetaData) {
              if (type == '36' && !osGridRef) {
                _.set(properties, 'Default.selectedValue', '');
              } else {
                _.set(properties, 'Default.selectedValue', address + ' (' + (type == '36' ? osGridRef : lat + ', ' + long) + ')');
              }
            } else {
              if (type == '36') {
                _.set(properties, 'Default.selectedValue', osGridRef);
              } else {
                _.set(properties, 'Default.selectedValue', lat ? lat + ', ' + long : '');
              }
            }

            self.onChangeModelValue(uid, properties.ControlType, properties['Data Field Name'].selectedValue, properties.Default.selectedValue);
            /* if(eventsDetail && eventsDetail.change) {
              self.onEvent(eventsDetail.change.selectedValue);
            } */
            ctrl.cancel();
          });
        };
        this.cancel = function () {
          modalInstance.dismiss('cancel');
        };
      }
    });

    let setMarker = function (map, latitude, longitude) {
      clearMarker();
      marker = new self.maps.Marker({
        position: {
          lat: latitude,
          lng: longitude
        },
        map: map
      });
      lat = parseFloat(latitude.toFixed(8));
      long = parseFloat(longitude.toFixed(8));
      osGridRef = self.getGridRef({
        lat: lat,
        lng: long
      });
    }

    modalInstance.rendered.then(function () {
      let ukLatLang = {
        lat: 53.54030739150022,
        lng: -1.7578125
      };
      let zoom = type == '36' ? 5 : 1;
      if (lat) {
        zoom = 18;
      }
      let center = (!lat && type == '36') ? ukLatLang : {
        lat: lat || 0,
        lng: long || 0
      };
      let map = new self.maps.Map(self.$document[0].querySelector('.map'), {
        center: center,
        scrollwheel: true,
        zoom: zoom,
        size: new self.maps.Size('100%', '100%'),
        disableDefaultUI: true
      });

      let input = document.getElementById('map-search-box');
      let searchBox = new self.maps.places.SearchBox(input);
      map.controls[self.maps.ControlPosition.TOP_LEFT].push(input);

      map.addListener('bounds_changed', function () {
        searchBox.setBounds(map.getBounds());
      });

      searchBox.addListener('places_changed', function () {
        let places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        clearMarker();

        let bounds = new self.maps.LatLngBounds();
        places.forEach(function (place) {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
      });

      map.addListener('click', function (e) {
        setMarker(map, e.latLng.lat(), e.latLng.lng());
      });

      lat && long && setMarker(map, lat, long);
    });
    }).catch((err) => {
      console.error('Failed to load Google Maps:', err);
    });
  }

  getGridRef(pos) {
    let wgs84 = new geoTools.GT_WGS84();
    wgs84.setDegrees(pos.lat, pos.lng);
    let osgb = wgs84.getOSGB(),
      gridref10Dig = osgb.getGridRef(5),
      gridref6Dig = osgb.getGridRef(3);

    if ("Coordinate not within Great Britain" === osgb.status || (gridref10Dig.indexOf("undefined") > -1 || gridref6Dig.indexOf("undefined") > -1)) {
      gridref10Dig = "";
      gridref6Dig = "";
    }

    return gridref10Dig;
  }

  convertGridRef(gridref10Dig) {
    var osgb = new geoTools.GT_OSGB();
    if (osgb.parseGridRef(gridref10Dig)) {
      var wgs84 = osgb.getWGS84();
      return {
        lat: wgs84.latitude,
        long: wgs84.longitude
      };
    } else {
      return {
        lat: '',
        long: ''
      };
    }
  }

  resetDefaultForRadio(value, list) {
    if (list.length) {
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        element.selectedValue.name = '';
      }
    }
    value.selectedValue.name = true;
  }

  filterDropdownOption(parentAttr, data) {
    let list = [];
    if (data.length) {
      for (var i = 0; i < data.length; i++) {
        var element = data[i];
        if (element.id && this.filterOption.filterList && Object.keys(this.filterOption.filterList).length > 0) {
          var filterList = this.filterOption.filterList[parentAttr.properties.Basic["Field Name"].selectedValue] || [];
          if (!(filterList.length > 0 && filterList.indexOf(element.id) < 0)) {
            list.push(element);
          }
        } else {
          list.push(element);
        }
      }
    }
    return list;
  }

  selectAllCheckboxOption(event, list) {
    event.stopPropagation();
    list = list['Data Source'].table.list;
    for (var i = 0; i < list.length; ++i) {
      list[i].selectedValue.name = event.currentTarget.checked;
    }
  }
  selectAllDropdownOption(event, property) {
    event.stopPropagation();
    var list = property['Data Source'].table.list, selectedArray = [];
    if (event.currentTarget.checked) {
      for (var i = 0; i < list.length; ++i) {
        selectedArray.push(list[i].Value.name);
      }
      property.Basic.Value.selectedValue = selectedArray;
    } else {
      property.Basic.Value.selectedValue = [];
    }
  }

  isDisableDropdown(event, property) {
    property.Basic.FilterValue.isFilterValue = 1;
    if (event.currentTarget.checked) {
      property.Basic.FilterValue.isFilterValue = 2;
    }
    this.selectAllDropdownOption(event, property);
  }
  isDisableCheckbox(event, property) {
    property.Basic.FilterValue.isFilterValue = 1;
    if (event.currentTarget.checked) {
      property.Basic.FilterValue.isFilterValue = 2;
    }
    this.selectAllCheckboxOption(event, property);
  }

  getPrintViewJson(viewData, languageData) {
    if (!viewData.ORI_PRINT_VIEW && viewData.ORI_VIEW) {
      let selectedItems = this.Util.returnSelectedForCopy(_.get(viewData, 'ORI_VIEW.controls.A', []), [], false, true);
      let copiedItems = angular.copy(selectedItems);
      for (let i = 0; i < copiedItems.length; i++) {
        copiedItems[i].selected = false;
        this.convertToReadOnly(copiedItems[i]);
      }
      let defaultName = angular.copy(this.defaultView);
      defaultName.viewName = 'ORI_PRINT_VIEW';
      viewData['ORI_PRINT_VIEW'] = defaultName;
      viewData['ORI_PRINT_VIEW'].controls.A = copiedItems;
      viewData['ORI_PRINT_VIEW'].removeOnLoad = true;
    }

    if (!viewData.RES_PRINT_VIEW && viewData.RES_VIEW) {
      let selectedItems = this.Util.returnSelectedForCopy(_.get(viewData, 'RES_VIEW.controls.A', []), [], false, true);
      let copiedItems = angular.copy(selectedItems);
      for (let i = 0; i < copiedItems.length; i++) {
        copiedItems[i].selected = false;
        this.convertToReadOnly(copiedItems[i]);
      }
      let defaultName = angular.copy(this.defaultView);
      defaultName.viewName = 'RES_PRINT_VIEW';
      viewData['RES_PRINT_VIEW'] = defaultName;
      viewData['RES_PRINT_VIEW'].controls.A = copiedItems;
      viewData['RES_PRINT_VIEW'].removeOnLoad = true;
    }

  }

  getColumnWidth(item, index, row) {
    var width = 'auto';
    if(item.type == "Layout") {
      width = item.width[index];
      return width;
    }

    if (item.data[row][index].colspan && item.data[row][index].colspan > 0) {
      width = 'auto';
    } else {
      width = item.width[index]
    }
    return width;
  }

  publishWarning() {
    let msg =this.$translate.instant('publish.warning')
    this.ngNotification.warning({
      message: msg, positionX: 'center', replaceMessage: true, templateUrl: "infrom_msg_for_publish.html", scope: this.$scope, delay: false
    });
    this.publishWarn = true;
  }
  publish() {
    let self = this;
    let timeStamp = new Date().getTime();
    if (self.editTempName) {
      self.editTempNameCancle();
    }
    
    if (self.params.formName.match(/[|<>\\/:?*"'$#]/gi)) {                
      self.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
      return;  
    }
    if(self.config.for === 'Marketplace') {
      window.top.postMessage('PublishBtnClicked', "*");
    }

    self.validateAndSave(function () {
      self.publishWarn = undefined;
      self.loading = true;
      let formTypeID = self.params.id.formTypeId || self.params.id.formTypeID;
      let instanceGroupId = self.params.id.instanceGroupId;
      let extraParams = self.params.extraParams ? JSON.stringify(self.params.extraParams) : '';
      let formtemplateType = self.params.id.formSubTemplateType ? self.params.id.formSubTemplateType : "0";
      let responsePattern = self.params.id.responsePattern ? self.params.id.responsePattern : 0;
      self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
      self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
      self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
      self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
      self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
      let data: any = {
        "timeStamp": timeStamp,
        "formTypeId": formTypeID,
        "projectId": self.params.id.projectId,
        "instanceGroupId": instanceGroupId,
        "for": self.config.for,
        "formSubTemplateType": self.params.id.formSubTemplateType,
        "responsePattern": self.params.id.responsePattern,
        "name": self.params.formName,
        "formProperties": self.formProperties
      };

      if (self.config.for == 'Marketplace') {
        data = {
          "timeStamp": timeStamp,
          "formTypeId": formTypeID,
          "projectId": self.params.id.projectId,
          "for": self.config.for,
          "formSubTemplateType": formtemplateType,
          "responsePattern": responsePattern,
          "name": self.params.formName,
          "extraParams": extraParams
        }
      }

      self.$http({
        'url': '/publish',
        'method': 'POST',
        'data': data,
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        'withCredentials': true
      }).then(response => {
        self.ngNotification.success({ message: 'Operation successful.', positionX: 'center', replaceMessage: true });
        //var publishDataString = 'publishData::'+JSON.stringify(response.data);
        const repsonseData = response.data;
        repsonseData.publish = true;
        if (self.config.for == 'Marketplace') {
          window.top.postMessage(repsonseData, "*");
        } else {
          window.opener.postMessage(repsonseData, "*");
        }
        (<any>window).onbeforeunload = function () { };
        self.$window.close();
      }, response => {
        let msg =self.$translate.instant('error.while.processing.request')
        self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
        self.loading = false;
      });
    }, true, true);
    self.publishWarn = false;
  }

  discardDraft() {
    let self = this;
    this.loading = true;
    this.$http({
      'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.DISCARD_DRAFT + this.params.id.formTypeId + '/' + this.params.id.projectId,
      'method': 'GET',
      'data': {},
      'withCredentials': true,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      },
    }).then(response => {
      let msg=self.$translate.instant('operation.successful');
      self.ngNotification.success({ message: msg, positionX: 'center', replaceMessage: true });
      self.loading = false;
      self.getFormDesignData();
    }, response => {
      let msg=self.$translate.instant('error.while.processing.request');
      self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
      self.loading = false;
    });
  }

  editTemplateName() {
    let self = this;
    this.tempTemplateName = self.params.formName;
    self.editTempName = true;
  }

  editTemplateNameSave() {
    let self = this;
    var letters = /^[A-Za-z0-9\_\-\!\~\%\&\(\)\+\,\.\=\@\[\b\]\^\`\{\}\s]+$/;
    if (self.params.formName.match(letters)) {
      self.editTempName = false;
      var updatedTemplateName = self.params.formName;
      let data: any = {
        "templateName": updatedTemplateName,
        "formTypeId": self.params.id.formTypeId || self.params.id.formTypeID,
        "projectId": self.params.id.projectId
      };
      let httpParams: any = {
        'url': (<any>window).properties.service.commonApiUrl + ACTION_IDS.UPDATE_TEMPLATENAME,
        'method': 'POST',
        'data': data,
        'headers': {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        'withCredentials': true
      }
      httpParams.transformRequest = function (obj) {
        var str = [];
        for (var p in obj)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        return str.join("&");
      }
      this.loading = true;
      this.$http(httpParams).then(response => {
        self.ngNotification.success({ message: 'Operation successful.', positionX: 'center', replaceMessage: true });
        self.loading = false;
        self.params.formName = updatedTemplateName;
        var renameStr = 'renameData::' + updatedTemplateName;
        if (self.config.for == 'Marketplace') {
          window.top.postMessage(renameStr, "*");
        } else {
          window.opener.postMessage(renameStr, "*");
        }
      }, function errorCallback(response) {
        self.ngNotification.error({ message: 'There was an error processing your request.', positionX: 'center', replaceMessage: true });
        self.loading = false;
      });
    } else {
      self.ngNotification.error({ message: 'Invalid characters entered. Characters (#,\\,/,:,*,?,<,>,|,$,single quote,double quotes), HTML Tags or any character with ASCII value less than 32 are not allowed.', positionX: 'center', replaceMessage: true });
    }

  }

  editTempNameCancle() {
    let self = this;
    self.params.formName = this.tempTemplateName;
    this.tempTemplateName = '';
    self.editTempName = false;
  }

  deselectAll(event) {
    if(event && event.shiftKey){
      return;
    }
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    if (selected.length) {
      for (let i = 0; i < selected.length; i++) {
        selected[i].selected = false;
      }
    }
    this.selectedItemDomain = [];
    this.selectedItemIndex = null;
  }

  deselectAllOtherViews() {
    let views = Object.keys(this.views);
    views.forEach((view)=>{
      if(this.views[view].viewName != this.selectedItemView){
        let selectedItemOtherView = this.Util.returnSelected(this.views[view].controls.A);
        selectedItemOtherView.forEach((item, i)=>{
            item['selected'] = false;
      }, this)
    }
    }, this)
  }

  clearAllCell(){
    let ele = angular.element('.canvas').find('.eng-selected-item');
    if(ele.length){
        for(var i=0; i< ele.length; i++ ){
            ele.removeClass('eng-selected-item');
        }
    } 
  }

  removeLanguageLabels(viewName, data = {}) {
    if (Object.keys(data).length) {
      for (var languageId in data) {
        if (data.hasOwnProperty(languageId)) {
          var element = data[languageId];
          if (Object.keys(element).length) {
            for (var el in element) {
              if (element.hasOwnProperty(el) && el.indexOf(viewName) == 0) {
                delete element[el];
              }
            }
          }
        }
      }
    }
  }

  setStyle($event) {
    if (this.mousemoved) {
      angular.element('.canvas').find('table').find('tr').children('td').each(function (i, el) {
        el.style.height = el.clientHeight + 'px';
      });
      this.mousemoved = false;
    }
  }

  removeStyle($event) {
    if (!this.mousemoved) {
      angular.element($event.currentTarget).find('td').css('height', '');
      this.mousemoved = true;
    }
  }

  //setting same parentNode id for textbox and display fields if they are added under same repeating table
  updateChildId(item,event){
    var tableid= angular.element(event.target).parents("div[type=RepeatingTable]").attr("repeating-table-id");
    var isFooter = angular.element(event.target).parents("tr[type=footer]");
    if(item.properties.Basic.parentNode){
      if(tableid)
        item.properties.Basic.parentNode.id = "repeatingTable"+tableid;
      else{
        item.properties.Basic.parentNode.id = 0;
        item.properties.Basic.Type.numberUnderRepeatingTable = false
      }
      if(item.type.toLowerCase() == "display field"){
        if(isFooter.length) item.properties.Basic.parentNode.footer = true;
        else item.properties.Basic.parentNode.footer = false;
      } 
    }
  }

  /**
   * Map of old and new field names
   */
  renamedFieldNames: any = {};

  /**
   * Map of old and new data field names
   */
  renamedDataFieldNames: any = {};

  /**
   * Perform migration for all controls from all views and set/update/delete property based on requirement
   */
  doInitialMigration() {
    let self = this;
    if(!self.views) {
      return;
    }

    let controls = self.Util.getAllControls();
    for (const key in controls) {
      const control = controls[key];
      self.doMigration(control, controls);
    }
    // controls.forEach((control) => {
    //   self.doMigration(control, controls);
    // });

    let regex = /(^\{\{.*?\}\}$)/;
    function renamedFxValue(curName, newName) {
      controls.forEach((control) => {
        let controlValue = _.get(control, 'properties.Basic.Value.selectedValue', '');
        if (controlValue && typeof controlValue == 'string' && controlValue.match && controlValue.match(regex)) {
            let val = controlValue.replace('{{', '').replace('}}', '');
            if(val && (curName == val)) {
                _.set(control, 'properties.Basic.Value.selectedValue', '{{' + newName + '}}');
                _.set(control, 'properties.Basic.DSName.selectedValue', newName);
            }
        }

        //Migrate' derivedFromFieldName' value
        let derivedFromFieldName = _.get(control, 'derivedFromFieldName', '');
        if(derivedFromFieldName && (curName == derivedFromFieldName)) {
            _.set(control, 'derivedFromFieldName', newName);
        }

        //Migrate' copiedFrom' value
        let copiedFrom = _.get(control, 'copiedFrom', '');
        if(copiedFrom && (curName == copiedFrom)) {
          _.set(control, 'copiedFrom', newName);
        }

        //Migrate' DSName' value
        let curDSName = _.get(control, 'properties.Basic.DSName.selectedValue', '');
        if (curDSName && (curName == curDSName)) {
          _.set(control, 'properties.Basic.DSName.selectedValue', newName);
        }
      });
    };

    //Rename data field in FX value if same data field name is used
    for(let fieldName in this.renamedFieldNames) {
      renamedFxValue(fieldName, this.renamedFieldNames[fieldName]);
      self.Util.replaceFieldNameInCodeEditor(controls, fieldName, this.renamedFieldNames[fieldName]);
    }
    for(let dataFieldName in this.renamedDataFieldNames) {
      renamedFxValue(dataFieldName, this.renamedDataFieldNames[dataFieldName]);
      self.Util.replaceDataFieldNameInCodeEditor(controls, dataFieldName, this.renamedDataFieldNames[dataFieldName]);
    }
    this.renamedFieldNames= {};
    this.renamedDataFieldNames= {};
    
    controls.forEach((control) => {
      //Migrate' copiedFrom' value
      let copiedFrom = _.get(control, 'copiedFrom', '');
      if(copiedFrom && (copiedFrom.indexOf('-') != -1 || copiedFrom.indexOf('.') != -1 || copiedFrom.indexOf('___') != -1)) {
          copiedFrom = this.Util.replaceAllMatches(copiedFrom, '-', '_');
          copiedFrom = this.Util.replaceAllMatches(copiedFrom, '.', '_');
          copiedFrom = this.Util.replaceUnderscoresValue(copiedFrom);
          _.set(control, 'copiedFrom', copiedFrom);
        }

        if(!control.propMigrated && copiedFrom && self.readOnlyControlsToUpdate.indexOf(copiedFrom) == -1) {
          if(control.type != "Table" && control.type != "Layout" && control.type != "RepeatingTable") {
            self.readOnlyControlsToUpdate.push(copiedFrom);
          }else {
            _.set(control.properties, "Display.Hidden.hidden", true);
          }
        }

      //Migrate' DSName' value
      let curDSName = _.get(control, 'properties.Basic.DSName.selectedValue', '');
      if (curDSName && (curDSName.indexOf('-') != -1 || curDSName.indexOf('.') != -1 || curDSName.indexOf('___') != -1)) {
        curDSName = this.Util.replaceAllMatches(curDSName, '-', '_');
        curDSName = this.Util.replaceAllMatches(curDSName, '.', '_');
        curDSName = this.Util.replaceUnderscoresValue(curDSName);
        _.set(control, 'properties.Basic.DSName.selectedValue', curDSName);
      }
    });

    self.processToUpdateReadOnlyControlProperties();
  }

  incrementCount:any = 0;
  /**
   * @return {Number} - Unique incremental number
   */
  getIncrementCount() {
    return ++this.incrementCount;
  }

  /**
   * @brief Add missing properties or newly introduced properties for old design.
   * @param {object} control
   */
  doMigration(control, allControls) {
    if(!control || !control.type || !control.properties) {
        return;
    }
    
    if(this.config && this.config.for == "Meta-Data") {
      return;
    }
    
    let properties = control.properties;
    let migrateDataFieldName = false;
    try {
        
      switch(control.type) {
          case 'Textbox':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }

              if(properties && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE' && !properties.ControlStyle) {
                properties['ControlStyle'] = angular.copy(properties.Style);
                properties['ControlStyle'].Name.selectedValue = 'control.style';
                delete properties['ControlStyle']['font-style-group'].members['background-color']
              }

              if (properties && properties.Style && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE') {
                properties.Style.Name.selectedValue = 'label.style'
              }
    
              if(properties && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE' && !properties.Margin) {
                properties['Margin'] = angular.copy(ControlProperties.TextboxProperties.Margin); // padding
              }

              if(properties && properties.Display && !properties.Display['HasMic']) {
                properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
              }

              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.TextboxProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Textbox';
              }

              if(properties.Basic && !properties.Basic.Validate && properties.Advance.Validate){
                properties.Basic.Validate = angular.copy(properties.Advance.Validate);
                properties.Basic.Validate.onChangeFunction = 'onFormatTypeChanged'; 
                properties.Basic.Validate.name = 'format';
                delete properties.Advance.Validate;
                properties.Basic.DigitSeparator = angular.copy(ControlProperties.TextboxProperties.Basic.DigitSeparator);
                properties.Basic.DecimalPlaces = angular.copy(ControlProperties.TextboxProperties.Basic.DecimalPlaces);
                properties.Basic.DecimalThousandSeparator = angular.copy(ControlProperties.TextboxProperties.Basic.DecimalThousandSeparator);

                if(this.numberFormatEnabled && (properties.Basic.Validate.selectedValue == 'Integer' || properties.Basic.Validate.selectedValue == 'Decimal')) {
                  properties.Basic.DigitSeparator.hidden = false;
                  if(properties.Basic.Validate.selectedValue == 'Decimal') {
                    properties.Basic.DecimalPlaces.hidden = false;
                  }
                  properties.Basic.DecimalPlaces.selectedValue = '0';
                }
              }

              // add hasMic property in display object
              if(properties && properties.Display && !properties.Display['HasMic']) {
                properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
              }

              if(!this.numberFormatEnabled) {
                properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.selectedValue = false);
                properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.hidden = true);
                properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.hidden = true);
                properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.selectedValue = '0');
              }
          if (!properties.Display.Wraptext) {
            properties.Display.Wraptext = angular.copy(ControlProperties.TextboxProperties.Display.Wraptext)
          }

              migrateDataFieldName = true;
              break;
          case 'Text-Area':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.TextareaProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Textarea';
              }

              if(properties.Basic && !properties.Basic.Validate && properties.Advance.Validate){
                properties.Basic.Validate = angular.copy(properties.Advance.Validate);
                properties.Basic.Validate.onChangeFunction = 'onFormatTypeChanged'; 
                properties.Basic.Validate.name = 'format';
                delete properties.Advance.Validate;
                properties.Basic.DigitSeparator = angular.copy(ControlProperties.TextareaProperties.Basic.DigitSeparator);
                properties.Basic.DecimalPlaces = angular.copy(ControlProperties.TextareaProperties.Basic.DecimalPlaces);
                properties.Basic.DecimalThousandSeparator = angular.copy(ControlProperties.TextareaProperties.Basic.DecimalThousandSeparator);

                if(this.numberFormatEnabled && (properties.Basic.Validate.selectedValue == 'Integer' || properties.Basic.Validate.selectedValue == 'Decimal')) {
                  properties.Basic.DigitSeparator.hidden = false;
                  if(properties.Basic.Validate.selectedValue == 'Decimal') {
                    properties.Basic.DecimalPlaces.hidden = false;
                  }
                  properties.Basic.DecimalPlaces.selectedValue = '0';
                }
              }

              if(!this.numberFormatEnabled) {
                properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.selectedValue = false);
                properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.hidden = true);
                properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.hidden = true);
                properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.selectedValue = '0');
              }
              if (properties.Size) {
                delete properties.Size;
              }    
              migrateDataFieldName = true;
              break;
          case 'Rich-Text-Box':
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.RichTextAreaProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'RichTextArea';
              }
              if (properties.Display && !properties.Display['Char-Limit']) {
                properties.Display['Char-Limit'] = angular.copy(ControlProperties.RichTextAreaProperties.Display['Char-Limit']);
              }

              // add hasMic property in display object
              if(properties && properties.Display && !properties.Display['HasMic']) {
                properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
              }

              migrateDataFieldName = true;
              break;
          case 'Attachment':
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.AttachmentProperties.Events);
              }
              if(properties.Basic && !properties.Basic['Name']) {
                  properties.Basic['Name'] = angular.copy(ControlProperties.AttachmentProperties.Basic['Name'])
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Attachment';
              }
              if (properties.Display && !properties.Display['Generate Thumbnail']) {
                properties.Display['Generate Thumbnail'] = angular.copy(ControlProperties.AttachmentProperties.Display['Generate Thumbnail']);
              }
              if (properties.Display && !properties.Display['Caption']) {
                properties.Display['Caption'] = angular.copy(ControlProperties.AttachmentProperties.Display['Caption']);
              }
              if (properties.Display && !properties.Display['Caption Position']) {
                properties.Display['Caption Position'] = angular.copy(ControlProperties.AttachmentProperties.Display['Caption Position']);
              }
              if (properties.Display && !properties.Display['Thumbnail Size']) {
                properties.Display['Thumbnail Size'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Size']);
              }
              if (properties.Display && !properties.Display['Thumbnail Width']) {
                properties.Display['Thumbnail Width'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Width']);
              }
              if (properties.Display && !properties.Display['Thumbnail Height']) {
                properties.Display['Thumbnail Height'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Height']);
              }
              if (properties.Basic && properties.Basic['Value']) {
                properties.Basic['Value'] = angular.copy(ControlProperties.AttachmentProperties.Basic['Value']);
              }
              if(properties.Display && !properties.Display['Embedded Attachment']) {
                properties.Display['Embedded Attachment'] = angular.copy(ControlProperties.AttachmentProperties.Display['Embedded Attachment']);
              }
              migrateDataFieldName = true;
              break;
          case 'Button':
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.ButtonProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Button';
              }
              break;
          case 'ToggleButton':
            if (properties && properties.ControlStyle) {
              properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
            }
            if (properties && properties.Style) {
              properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
            }
            if(!properties.Events){
                properties.Events = angular.copy(ControlProperties.ToggleButtonProperties.Events);
            }
            if(properties.Basic && !properties.Basic.ControlType) {
                properties.Basic.ControlType = 'ToggleButton';
            }
            if (properties.Basic && !properties.Basic['ValueOn']) {
              properties.Basic['ValueOn'] = angular.copy(ControlProperties.ToggleButtonProperties.Basic['ValueOn']);
            }
            if (properties.Basic && !properties.Basic['ValueOff']) {
              properties.Basic['ValueOff'] = angular.copy(ControlProperties.ToggleButtonProperties.Basic['ValueOff']);
            }
           
            migrateDataFieldName = true;
            break;
          case 'Hyperlink':
            if (properties && properties.ControlStyle) {
              properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
            }
            if (properties && properties.Style) {
              properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
            }
            if(!properties.Events){
              properties.Events = angular.copy(ControlProperties.HyperlinkProperties.Events);
            }
            if(properties.Basic['Value']) {
              properties.Basic['Value'].onChangeFunction = 'checkRequired';
            }
            if(properties.Basic && !properties.Basic.ControlType){
                properties.Basic.ControlType = 'Hyperlink';
            }
            migrateDataFieldName = true;
          break;
          case 'Radio':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              } 
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.RadioProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Radio';
              }
              if(properties.Basic['Spread Columns']){
                delete properties.Basic['Spread Columns']
              }
               if(!(properties.Basic['Display Format'])){
                control.properties.Basic['Display Format'] = angular.copy(ControlProperties.RadioProperties.Basic['Display Format'])
             }
             if(!(properties.Basic['Number'])){
              properties.Basic['Number']=angular.copy(ControlProperties.RadioProperties.Basic['Number'])
            }
              
              migrateDataFieldName = true;
              break;
          case 'Layout':
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.LayoutProperties.Events);
              }
              if(!properties.Basic) {
                  //Set Basic with Field name value
                  properties.Basic = angular.copy(ControlProperties.LayoutProperties.Basic);
                  properties.Basic['Field Name'].selectedValue = control.type + '__' + this.getIncrementCount();
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Layout';
              }

              if(properties.Basic && properties.Basic.Name && properties.Basic.Name.hideSection){
                properties.Basic.Name.hideSection = false;
              }

              if(!properties.Display) {
                properties.Display = angular.copy(ControlProperties.LayoutProperties.Display);
              }

              if(!properties.Display.RemoveOptions) {
                properties.Display.RemoveOptions = angular.copy(ControlProperties.LayoutProperties.Display.RemoveOptions);
              }

              if(properties.Style){
                properties.Style['style-group'].members = {};
                delete properties.Style['font-style-group'].members['font-family'];
                delete properties.Style['font-style-group'].members['font-size'];
              }

              if(!control.width) {
                control.ids = [];
                control.selectedRows = [];
                control.width = {};
                control.reset = false;
              }

              control.data.forEach((dataObj)=>{
                if(dataObj.style && ( dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')){
                  dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
                }
              })
    
              break;
          case 'Table':
            if(!properties.Borders['Name']) {
                properties.Borders['Name'] = angular.copy(ControlProperties.TableProperties.Borders['Name'])
            }

            if(!properties.Merge['Name']) {
                properties.Merge['Name'] = angular.copy(ControlProperties.TableProperties.Merge['Name'])
            }
            
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.TableProperties.Events);
              }

            if (!properties.Display['Fit-to-Screen']) {
                properties.Display['Fit-to-Screen'] = angular.copy(ControlProperties.TableProperties.Display['Fit-to-Screen']);
             }
              if(!properties.Basic) {
                  //Set Basic with Field name value
                  properties.Basic = angular.copy(ControlProperties.TableProperties.Basic);
                  properties.Basic['Field Name'].selectedValue = control.type + '__' + this.getIncrementCount();
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Table';
              }
              if(properties.Basic && properties.Basic.Name && properties.Basic.Name.hideSection){
                properties.Basic.Name.hideSection = false;
              }

              if(properties.Style){
                properties.Style['style-group'].members = {};
                delete properties.Style['font-style-group'].members['font-family'];
                delete properties.Style['font-style-group'].members['font-size'];
              }
              
              control.data.forEach((row)=>{
                row.forEach((dataObj)=>{
                  if(dataObj.style && ( dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')){
                    dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
                  }
                })
              });
    
              break;
          case 'RepeatingTable':
              if(properties && properties.Borders && !properties.Borders['Name']) {
                properties.Borders['Name'] = angular.copy(ControlProperties.RepeatingTableProperties.Borders['Name'])
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.RepeatingTableProperties.Events);
              }
              if (!properties.Display['Fit-to-Screen']) {
                properties.Display['Fit-to-Screen'] = angular.copy(ControlProperties.TableProperties.Display['Fit-to-Screen']);
              }
              
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'RepeatingTable';
              }

              if(!properties.Display) {
                properties.Display = angular.copy(ControlProperties.RepeatingTableProperties.Display);
              }

              if(!properties.Display.RemoveOptions) {
                properties.Display.RemoveOptions = angular.copy(ControlProperties.RepeatingTableProperties.Display.RemoveOptions);
              }
              
              if (properties.Events && !properties.Events.OnInsertRow) {
                properties.Events['OnInsertRow'] = angular.copy(ControlProperties.RepeatingTableProperties.Events.OnInsertRow);
              }
              
              if (properties.Events && !properties.Events.OnDeleteRow) {
                properties.Events['OnDeleteRow'] = angular.copy(ControlProperties.RepeatingTableProperties.Events.OnDeleteRow);
              }

              if(properties && !properties.EvenOddRowStyle) {
                properties['EvenOddRowStyle'] = angular.copy(ControlProperties.RepeatingTableProperties.EvenOddRowStyle);
              }

              if(properties.Style){
                properties.Style['style-group'].members = {};
                delete properties.Style['font-style-group'].members['font-family'];
                delete properties.Style['font-style-group'].members['font-size'];
              }

              if(!control.width) {
                control.ids = [];
                control.selectedRows = [];
                control.width = {};
                control.reset = false;
              }

              if(!properties['InsertButtonStyle']) {
                properties['InsertButtonStyle'] = angular.copy(ControlProperties.RepeatingTableProperties.InsertButtonStyle);
              }

              control.data[0].forEach((dataObj)=>{
                if(dataObj.style && ( dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')){
                  dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
                }
              })
              control.header_data[0].forEach((dataObj)=>{
                if(dataObj.style && ( dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')){
                  dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
                }
              })
              control.footer_data[0].forEach((dataObj)=>{
                if(dataObj.style && ( dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')){
                  dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
                }
              })
              this.findAndAddDataFieldName(control, allControls);
              migrateDataFieldName = true;
              break;
          case 'Section':
              if (!properties.Events) {
                properties.Events = angular.copy(ControlProperties.SectionProperties.Events);
              }
              if (properties.Basic && !properties.Basic.ControlType) {
                properties.Basic.ControlType = 'Section';
              }
    
              if (properties.Style) {
                properties.Style['style-group'].members = {};
                delete properties.Style['font-style-group'].members['font-family'];
                delete properties.Style['font-style-group'].members['font-size'];
              }
              migrateDataFieldName = true;
              break;
          case 'Map':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.MapProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Map';
              }
              migrateDataFieldName = true;
              break;
          case 'Signature':
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Basic['Name']) {
                properties.Basic['Name'] = angular.copy(ControlProperties.SignatureProperties.Basic['Name'])
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.SignatureProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Signature';
              }
              if(!properties.Basic.Type){
                properties.Basic.Type = angular.copy(ControlProperties.SignatureProperties.Basic.Type);
              }
              migrateDataFieldName = true;
              break;
          case 'Checkbox':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.CheckboxProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Checkbox';
              }
              if(properties.Basic['Spread Columns']){
                delete properties.Basic['Spread Columns']
              }
              if(!(properties.Basic['Display Format'])){
                properties.Basic['Display Format'] = angular.copy(ControlProperties.CheckboxProperties.Basic['Display Format'])
             }
             if(!(properties.Basic['Number'])){
               properties.Basic['Number']=angular.copy(ControlProperties.CheckboxProperties.Basic['Number'])
             }
              migrateDataFieldName = true;
              break;
          case 'Image':
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Image';
              }
              break;
          case 'Label':
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Label';
              }
              break;
          case 'Dropdown':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Advance['App Status']) {
                  properties.Advance['App Status'] = angular.copy(ControlProperties.DropdownProperties.Advance['App Status'])
              }

              if(properties.Advance['App Status'].selectedValue) {
                properties["Data Source"].Source.selectedValue = '4';
                properties["Data Source"].forceToDisabled = true;
              }
              
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.DropdownProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Dropdown';
              }
            
               if(properties['Data Source'].Source.list){
                properties['Data Source'].Source.list = ControlProperties.DropdownProperties['Data Source'].Source.list
               }

               if(properties.Basic.Value.selectedValue.length > 0){
                if(Array.isArray(properties.Basic.Value.selectedValue)){
                  const data = properties.Basic.Value.selectedValue;
                  if(data && data[0].hasOwnProperty("Value")) {
                    properties.Basic.Value.selectedValue = data.map(el => el.Value.name).join(",").split(',');
                  }
                } else { 
                  properties.Basic.Value.selectedValue =  properties.Basic.Value.selectedValue ? properties.Basic.Value.selectedValue.split(','):[];
                }
              }
              if (properties && properties["Data Source"] && properties["Data Source"].customAttr && !properties["Data Source"].customAttr.hierarchyData) {
                properties["Data Source"].customAttr.hierarchyData = [];
              }
              if (properties && properties["Data Source"] && properties["Data Source"].customAttr && !properties["Data Source"].customAttr.hierarchyApplied) {
                properties["Data Source"].customAttr.hierarchyApplied = false;
              }
              migrateDataFieldName = true;
              break;
          case 'MultiDropdown':
            if (properties && properties.ControlStyle) {
              properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
            }
            if (properties && properties.Style) {
              properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
            }
            if(!properties.Events){
                properties.Events = angular.copy(ControlProperties.MultiDropdownProperties.Events);
            }
            if(properties.Basic && !properties.Basic.ControlType){
                properties.Basic.ControlType = 'MultiDropdown';
            }
            if (!properties["Data Source"].customAttr.hierarchyData) {
              properties["Data Source"].customAttr.hierarchyData = [];
            }
            if (!properties["Data Source"].customAttr.hierarchyApplied) {
              properties["Data Source"].customAttr.hierarchyApplied = false;
            }
            migrateDataFieldName = true;
            break;
          case 'Datepicker':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Advance['Closed Date']) {
                  properties.Advance['Closed Date'] = angular.copy(ControlProperties.DatepickerProperties.Advance['Closed Date'])
              }
              if(!properties.Basic.Default.dateType) {
                  properties.Basic.Default.dateType = "1";
              }
              if(!properties.Basic.Default.days) {
                  properties.Basic.Default.days = 0;
              }
              if(!properties.Events){
                  properties.Events = angular.copy(ControlProperties.DatepickerProperties.Events);
              }
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'Datepicker';
              }
              if(properties.Basic && properties.Basic['Display Format']) {
                properties.Basic['Display Format'].options = angular.copy(ControlProperties.DatepickerProperties.Basic['Display Format'].options);
              }
              properties.Basic['Display Format'].selectedValue = this.getDisplayFormat(properties);
              if(properties.Basic && !properties.Basic['Time']){
                properties.Basic['Time'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Time']);
                
              }
              if(properties.Basic && !properties.Basic['Time Format']){
                properties.Basic['Time Format'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Time Format']);
              }
              if (properties.Basic && !properties.Basic['Working Days']) {
                properties.Basic['Working Days'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Working Days']);
                if(properties.Basic['Default']['dateType'] == '2'){
                  properties.Basic['Working Days']['hidden'] = false;
                }
              }
              if (properties.Basic && !properties.Basic['Default'].onChangeFunction) {
                properties.Basic['Default']['onChangeFunction'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Default'].onChangeFunction);
              }

              migrateDataFieldName = true;
              break;
          case 'Timepicker':
            if (properties && properties.ControlStyle) {
              properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
            }
            if (properties && properties.Style) {
              properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
            }
            if(!properties.Events){
                properties.Events = angular.copy(ControlProperties.TimepickerProperties.Events);
            }
            if(properties.Basic && !properties.Basic.ControlType){
                properties.Basic.ControlType = 'Timepicker';
            }
            if(!properties.Basic.Default.timeType) {
              properties.Basic.Default.timeType = "1";
            }
            migrateDataFieldName = true;
            break;
          case 'Rating':
            if (properties && properties.ControlStyle) {
              properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
            }
            if (properties && properties.Style) {
              properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
            }
            migrateDataFieldName = true;
            break;
          case 'Display field':
              if (properties && properties.ControlStyle) {
                properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
              }
              if (properties && properties.Style) {
                properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
              }
              if(!properties.Basic['formula']) {
                  properties.Basic['formula'] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']);
                  if(!properties.Basic['formula']["edit"]) {
                      properties.Basic['formula']["edit"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["edit"])
                      properties.Basic['formula']["editText"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["editText"])
                      properties.Basic['formula']["editValue"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["editValue"])
                  }
              } 
              if(properties.Basic && !properties.Basic.ControlType){
                  properties.Basic.ControlType = 'DisplayField';
              }

              if (control.derivedControlType == 'Datepicker') {
                if (properties.Basic) {
                  this.getFieldNameForCalculatedField(control.derivedFromFieldName, properties);
                }
              }
              
              break;   
        case 'InlineAssocFiles':
          if (properties && properties.Style) {
            properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.InlineAssocFiles.Style['font-style-group'].members['font-family'].options);
          }
          if (!properties.Events) {
            properties.Events = angular.copy(ControlProperties.InlineAssocFiles.Events);
          }
          if (properties.Basic && !properties.Basic.ControlType) {
            properties.Basic.ControlType = 'InlineAssocFiles';
          }

          if(properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
              properties['Style']['font-style-group'].members['background-color'] = {
                type: 'color-picker',
                title: 'background.color',
                selectedValue: '#ffffff',
                icon: 'fa fa-paint-brush'
              };
            }

            if(properties && !properties['Borders']) {
              properties['Borders'] = angular.copy(ControlProperties.InlineAssocFiles.Borders);
            }

            if(properties && properties.Style && !properties['Style']['style-group']) {
              properties['Style']['style-group'] = angular.copy(ControlProperties.InlineAssocFiles.Style['style-group']);
            }

            if (properties && properties.ControlStyle &&
              properties.ControlStyle['font-style-group'] &&
              properties.ControlStyle['font-style-group'].members &&
              properties.ControlStyle['font-style-group'].members['font-size'] &&
              properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
              properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
            }
          migrateDataFieldName = true;
          break;
        case 'InlineAssocApps':
          if (properties && properties.Style) {
            properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.InlineAssocApps.Style['font-style-group'].members['font-family'].options);
          }

          if (properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
            properties['Style']['font-style-group'].members['background-color'] = {
              type: 'color-picker',
              title: 'background.color',
              selectedValue: '#ffffff',
              icon: 'fa fa-paint-brush'
            };
          }

          if (properties && !properties['Borders']) {
            properties['Borders'] = angular.copy(ControlProperties.InlineAssocApps.Borders);
          }

          if (properties && properties.Style && !properties['Style']['style-group']) {
            properties['Style']['style-group'] = angular.copy(ControlProperties.InlineAssocApps.Style['style-group']);
          }
          if (!properties.Events) {
            properties.Events = angular.copy(ControlProperties.InlineAssocApps.Events);
          }
          if (properties.Basic && !properties.Basic.ControlType) {
            properties.Basic.ControlType = 'InlineAssocApps';
          }

          if (properties && properties.ControlStyle &&
            properties.ControlStyle['font-style-group'] &&
            properties.ControlStyle['font-style-group'].members &&
            properties.ControlStyle['font-style-group'].members['font-size'] &&
            properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
            properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
          }
          migrateDataFieldName = true;
          break;
        case 'ViewAssociations':
          if (properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
            properties['Style']['font-style-group'].members['background-color'] = {
              type: 'color-picker',
              title: 'background.color',
              selectedValue: '#ffffff',
              icon: 'fa fa-paint-brush'
            };
          }

          if (properties && !properties['Borders']) {
            properties['Borders'] = angular.copy(ControlProperties.ViewAssociations.Borders);
          }

          if (properties && properties.Style && !properties['Style']['style-group']) {
            properties['Style']['style-group'] = angular.copy(ControlProperties.ViewAssociations.Style['style-group']);
          }

          if (properties && properties.ControlStyle &&
            properties.ControlStyle['font-style-group'] &&
            properties.ControlStyle['font-style-group'].members &&
            properties.ControlStyle['font-style-group'].members['font-size'] &&
            properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
            properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
          }
          migrateDataFieldName = true;
          break;      
      }

      //Migrate Field name
      if(properties.Basic && properties.Basic['Field Name']){
        let curFieldName = properties.Basic['Field Name'].selectedValue;
        let controlFieldName = curFieldName;
        if(controlFieldName.indexOf('-') != -1 || controlFieldName.indexOf('.') != -1 || controlFieldName.indexOf('___') != -1) {
          controlFieldName = this.Util.replaceAllMatches(controlFieldName, '-', '_');
          controlFieldName = this.Util.replaceAllMatches(controlFieldName, '.', '_');
          controlFieldName = this.Util.replaceUnderscoresValue(controlFieldName);
          this.renamedFieldNames[curFieldName] = controlFieldName;
          properties.Basic['Field Name'].selectedValue = controlFieldName;
        }
        properties.Basic['Field Name'].prevSelectedValue = controlFieldName;
      }

      //Set hidden property exluding Line control
      if(control.type != 'Line') {
          if(!properties.Display) {
              properties.Display = {
                  Name: {
                      selectedValue: 'Display',
                      hidden: true
                  }
              };
          }
          if(!properties.Display.Hidden){
              properties.Display.Hidden = {
                  name: "hidden",
                  selectedValue: false,
                  type: "checkbox"
              };
          }
      }

      //Set Data Field Name from Field Name property
      if(migrateDataFieldName) {
          if(properties.Basic && properties.Basic['Field Name'] && !properties.Basic['Data Field Name']) {
            properties.Basic['Data Field Name'] = Props.getDataFieldName(properties.Basic['Field Name'].selectedValue);
            properties.Basic['Data Field Name'].prevSelectedValue = properties.Basic['Field Name'].selectedValue;
          }

          if(properties.Basic && properties.Basic['Data Field Name']) {
            let curDataFieldName = properties.Basic['Data Field Name'].selectedValue;
            let controlDataFieldName = curDataFieldName;
            if(controlDataFieldName && (controlDataFieldName.indexOf('-') != -1 || controlDataFieldName.indexOf('.') != -1 || controlDataFieldName.indexOf('___') != -1)) {
              controlDataFieldName = this.Util.replaceAllMatches(controlDataFieldName, '-', '_');
              controlDataFieldName = this.Util.replaceAllMatches(controlDataFieldName, '.', '_');
              controlDataFieldName = this.Util.replaceUnderscoresValue(controlDataFieldName);
              this.renamedDataFieldNames[curDataFieldName] = controlDataFieldName;
              properties.Basic['Data Field Name'].selectedValue = controlDataFieldName;
            }

            properties.Basic['Data Field Name'].prevSelectedValue = controlDataFieldName;
          }

          if(control.readOnly || control.forceToReadOnly) {
            properties.Basic['Data Field Name'].disable = true;
          }
      }else if(properties.Basic && properties.Basic['Data Field Name']) {
          delete properties.Basic['Data Field Name'];
      }

      //Mark event as disable if control is paste as readonly control
      if(properties.Events && (control.readOnly || control.forceToReadOnly || control.copiedFrom)) {
          for(let event in properties.Events) {
              if(event != 'Name' && event != 'forceToDisabled') {
                properties.Events[event].disable = true;
              }
          }
      }
      
    }catch(e) {
      console.error('Failed to initial migration for control type is : ', control.type, e);
    }
      
  }

  findAndAddDataFieldName(control, allControls) {
    let datafieldname = _.get(control.properties, 'Basic["Data Field Name"].selectedValue');
    if (datafieldname === undefined) {
      let copiedFromRepeatingTable = control.copiedFromRepeatingTable;
      let pasteAsCalculatedFrom = control.pasteAsCalculatedFrom;
      if (control.copiedFrom) {
        control.forceToReadOnly = true;
      }
      if (copiedFromRepeatingTable === undefined && pasteAsCalculatedFrom === undefined) {
        copiedFromRepeatingTable = _.get(control.properties, 'Basic["Field Name"].selectedValue');
        this.addDatafieldName(control, copiedFromRepeatingTable, pasteAsCalculatedFrom !== undefined);
      }
      else if (copiedFromRepeatingTable !== undefined) {
        let newDFName = "";
        allControls.every(allElement => {
          if (_.get(allElement.properties, 'Basic["Field Name"].selectedValue') === copiedFromRepeatingTable) {
            if (!(_.get(allElement.properties, 'Basic["Data Field Name"].selectedValue'))) {
              this.findAndAddDataFieldName(allElement, allControls);
            }
            newDFName = _.get(allElement.properties, 'Basic["Data Field Name"].selectedValue');
          }
          return newDFName === "";
        });
        this.addDatafieldName(control, newDFName, pasteAsCalculatedFrom !== undefined);
      }
      else if (pasteAsCalculatedFrom !== undefined) {
        let newDFName = pasteAsCalculatedFrom;
        this.addDatafieldName(control, newDFName, true);
      }
    }
  }
  addDatafieldName(control, dataFieldName, hiddenView) {
    let newBasic = {};
    for (var key in control.properties.Basic) {
      newBasic[key] = control.properties.Basic[key];
      if (key === 'Field Name') {
        dataFieldName = !dataFieldName ? newBasic[key].selectedValue : dataFieldName; // if we get datafieldname empty;
        newBasic['Data Field Name'] = Props.getDataFieldName(dataFieldName);
        newBasic['Data Field Name'].prevSelectedValue = dataFieldName;
        if (hiddenView) {
          newBasic['Data Field Name'].hidden = hiddenView;
        }
      }
    }
    control.properties.Basic = newBasic;
  }

  getFieldNameForCalculatedField(dataFieldName,properties) {
    let controlList:any = this.getControlsByDataFieldName(dataFieldName);
    if (controlList.length >= 1) {
      controlList.forEach((control) => {
        if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'].selectedValue) {
          properties.Basic.RefFieldName =  control.properties.Basic['Field Name'].selectedValue;
        }
      });
    }
  }

  getValidationMsg(pattern) {
    try {
      if (!pattern) {
        return '';
      }

      let validationMsg = '';
      switch (pattern) {
        case 'Numeric':
          validationMsg = "Please enter a valid number.";
          break;
        case 'Alphanumeric':
          validationMsg = "Please enter only alphanumeric characters.";
          break;
        case "Email":
          validationMsg = "Please enter valid email address."
          break;
        case "Integer":
          validationMsg = "Please enter valid integer."
          break;
        case "Decimal":
          validationMsg = "Please enter valid decimal."
          break;
        case "Letters":
          validationMsg = "Please enter valid letters."
          break;
      }
      return validationMsg;
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  setErrorMessage(BasicProps, AdvanceProps) {
    let input = window.event && angular.element(window.event.target);
    setTimeout(() => {
      if(input && input.hasClass('ng-invalid')) {
        AdvanceProps.Tooltip.errorMessage = this.getValidationMsg(BasicProps.Validate.selectedValue)
      }else {
        AdvanceProps.Tooltip.errorMessage = ''
      }
    }, 0);
  }

  onEvent(handler) {
    //Don't set any proerpty via script logic as of now so mark this line as commented
    /* if(handler) {
      try {
        eval(handler);
      } catch(e) {
        console.error('Error when execute method on event. Method: ', e, handler)
      }
    } */
  }

  extractContent(s) {
    var span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };

  onChangeModelValue(uid, controlType, dataFieldName, value) {
    if(!uid || !controlType || !dataFieldName) {
      return;
    }

    
    let controlList = this.getControlsByDataFieldName(dataFieldName);
    if (controlType == 'Textbox') {
      this.$rootScope.$broadcast('controlValueChanged', controlList[0].properties.Basic);
    }
    
    if (controlType == "RichTextArea") {
      if (this.extractContent(value).length > controlList[0].properties.Display['Char-Limit'].selectedValue) {
        return;
      }
    }

    if(controlList.length == 1) {
      return;
    }
    //specially for timepicker
    if(typeof value == 'object' && controlType == 'Timepicker') {
      value = value['Basic']['Default'].selectedValue;
    }

    if(value == undefined || value == null) {
      value = '';
    }

    if(controlType == 'Checkbox' || controlType == 'Radio') {
      let selectedItemsVal = [];
      value.forEach && value.forEach((item) => {
        if(item.selectedValue && item.selectedValue.name) {
          selectedItemsVal.push(item.Value.name)
        }
      });
      value = selectedItemsVal.join(', ');
    }

    (<any>window).setPropValueByDataFieldName(dataFieldName, value, uid, true);
  }

  setWrapText(item, el) {
    clearTimeout(this.wrapTextTimeOut);
    this.wrapTextTimeOut = setTimeout(() => {
      this.setWrapForPasteControl(item.properties.Basic['Data Field Name'].selectedValue);
    }, 300)


    if (el && el.target || item.type === 'Text-Area') {
      if ((item.properties.Display.Wraptext && item.properties.Display.Wraptext.selectedValue) || item.type === 'Text-Area') {
        item.type === 'Text-Area' ? el.target.style.height = 74 + 'px' : el.target.style.height = 35 + 'px';
        el.target.style.height = el.target.scrollHeight + 'px';
        el.target.style.whiteSpace = 'normal';
        el.target.style.overflow = 'hidden';
      }
      else {
        el.target.style.height = '';
        el.target.style.whiteSpace = 'nowrap';
      }
    }
  }

  setWrapForPasteControl(dataFieldName) {
    let controlList = this.getControlsByDataFieldName(dataFieldName)
    if (controlList && controlList.length > 1) {
      for (let i = 0; i < controlList.length; i++) {
        let textareaId = controlList[i].uid;
        let textelem = angular.element("textarea[textarea-id=" + textareaId + "]");
        if (controlList[i].properties.Display && controlList[i].properties.Display.Wraptext.selectedValue) {
          textelem[0].style.whiteSpace = 'normal'
          textelem[0].style.height = textelem[0].scrollHeight + 'px';
        }
      }
    }
  }
  
  setWrapTextarea(item) {
    let textareaId = item.uid;
    textareaId && setTimeout(() => {
      let textelem = angular.element("textarea[textarea-id=" + textareaId + "]")
      for (let i = 0; i < textelem.length; i++) {
        if ((item.properties['Display'].Wraptext && item.properties['Display'].Wraptext.selectedValue && textelem[i].textLength > 0) || item.type==='Text-Area') {
          textelem[i].style.whiteSpace = 'pre-wrap';
          textelem[i].style.overflow = 'hidden';
          textelem[i].style.height = textelem[0].scrollHeight + 'px';
        }
      }
    }, 100);
  }

  selectAll() {
    let selected = this.selectedView.view.controls.A;
    let i = 0;
    if (selected.length) {
      for (i; i < selected.length; i++) {
        selected[i].selected = true;
      }
    }
    this.selectedItemDomain = selected;
    this.selectedItemIndex = i;
    this.selectedItemView = this.selectedView.view.viewName;
  }
  
    

    createArrayInRange(min, max) {
      let result = [];
      for (let i = min; i <= max; i++) { 
        result.push(i); 
      }
      return result;
    }

    getArray(item) {
      let stop = Number(item.properties.Basic.Max.selectedValue);
      let start = Number(item.properties.Basic.Min.selectedValue);
      let step = Number(item.properties.Basic.Step.selectedValue);
      const arrNumbers = Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
      return arrNumbers;
    }

    isNotEmpty(item) {
      var ele = angular.element('.form-builder').find(`[name="` + item.properties.Basic["Field Name"].selectedValue + `"]`);
  
      var empty = ele.hasClass("ng-empty") //true if empty
      var notEmpty = ele.hasClass("ng-not-empty") //true if notEmpty
      if (!empty && !notEmpty) {
        var value = item.properties.Basic.Value.selectedValue;
        return (value || value === undefined || value === 0);
      } else {
        return !empty;
      }
    }
  
    
    onPrintChangeHandler() {
      if(JSON.parse(this.isPuppeteerViewEnabled)) {
        this.printTypeText = 'advance.printing'
      } else {
        this.printTypeText = 'basic.printing'
      }
    }

  onKeyUp(event) {

    let contentEditable = event.target.isContentEditable;
    // Check if the platform is macOS
    const isMac = navigator.platform.includes('Mac');

    // Determine the correct modifier key based on the OS
    const modifierKey = isMac ? event.metaKey : event.ctrlKey;

    // Checking if any modal is open or only ctrl key is pressed or publish in progress
    if(angular.element('.modal-open').length || !modifierKey || this.publishWarn == undefined) {
      return;
    }
    
    if (modifierKey) {
      if (!contentEditable) {
        if (event.altKey && (event.keyCode == 65 || event.originalEvent["code"] == "KeyA")) {
          this.selectAll();
        }  else if (event.shiftKey && (event.keyCode == 86 || event.originalEvent["code"] == "KeyV")) {
          this.pasteAsReadOnly();
        } else if (event.altKey && (event.keyCode == 86 || event.originalEvent["code"] == "KeyV")) {
          this.pasteAsCalculatedField();
        }
      }

      if (event.altKey) {
        if (event.key === 'z' || event.key === 'Z') {
          this.$rootScope.$broadcast('undoRedo', 'UNDO');
        } else if (event.key === 'y' || event.key === 'Y') {
          this.$rootScope.$broadcast('undoRedo', 'REDO');
        } else if (event.keyCode == 83 || event.originalEvent["code"] == "KeyS") {
          this.validateAndSave(undefined);
        } else if (event.keyCode == 80 || event.originalEvent["code"] == "KeyP") {
          if (this.publishWarn != undefined){
            if (!this.publishWarn){
              this.publishWarning();
            } else {
              this.ngNotification.warning({
                message: '', positionX: 'center', replaceMessage: true, templateUrl: "notification_dismiss.html", scope: this.$scope
              });
              this.publish();
            }
          }
        } else if (event.keyCode == 67 || event.originalEvent["code"] == "KeyC") {
          this.ngNotification.warning({
            message: '', positionX: 'center', replaceMessage: true, templateUrl: "notification_dismiss.html", scope: this.$scope
          });
          if (this.publishWarn != undefined)
          this.publishWarn = false;
        }
      } else if (event.keyCode == 46 || event.originalEvent["code"] == "Delete") {
        this.remove(false);
      }
    }
  }

  /**
   * Handles the `keydown` event to implement undo and redo functionality for Mac users.
   * 
   * - Listens for `Command + Z` to trigger an undo action.
   * - Listens for `Command + Shift + Z` to trigger a redo action.
   * - Prevents default browser behavior for these key combinations.
   * - Ensures the functionality is only active when no modal is open and `publishWarn` is defined.
   * 
   * @param event - The keyboard event triggered by the user.
   */
  onKeyDown(event) {
    const isMac = navigator.platform.includes("Mac");
    if (!isMac) return;

    // Checking if any modal is open or only ctrl key is pressed or publish in progress
    if(angular.element('.modal-open').length || this.publishWarn == undefined) {
      return;
    }

    if (event.metaKey && !event.shiftKey && event.key.toLowerCase() === "z") {
      event.preventDefault();
      this.$rootScope.$broadcast("undoRedo", "UNDO");
    }
    if (event.metaKey && event.shiftKey && event.key.toLowerCase() === "z") {
      event.preventDefault();
      this.$rootScope.$broadcast("undoRedo", "REDO");
    }
  }

  openTemplateDialog(itemname) {
    var parentCtrl = this;
    this.$uibModal.open({
      component: itemname,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      resolve: {
        modalData: function () {
          return parentCtrl;
        }
      }
    }).result.then(function (result) {
      console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
    }, function (reason) {
      console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
    });;
  }
  
  getHeightRTextToolbar = function(controldata){
    const targetElement = angular.element('.form-builder').find(`[rta-field-name="${controldata}"]`).find('[text-angular-toolbar');
    const style = {
        position: 'absolute',
        right: '1rem',
    };
    
    return style['margin-top'] = targetElement && targetElement[0] && targetElement[0].clientHeight+24 , style;
  }

  openPrintSettingDialog() {
    let self = this;
    let printModalInstance = self.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'printSetting.html',
      backdrop: 'static',
      keyboard: false,
      controllerAs: '$printctrl',
      windowClass: 'print-settings-modal',
      appendTo: angular.element(self.$document[0].querySelector('.canvas')),
      controller: function () {
        this.printingOptions = {
          type: "false",
          isLandscape: "false"
        }
        this.printingOptions.type = self.isPuppeteerViewEnabled ? self.isPuppeteerViewEnabled : "false";
        this.printingOptions.isLandscape = self.isLandscape ? self.isLandscape : "false";
        this.save = function () {
          self.isPuppeteerViewEnabled = this.printingOptions.type;
          self.isLandscape = this.printingOptions.isLandscape;
          printModalInstance.close(false);
        };
        
        /**
         * @brief      Close dialog
         * @return     NULL
         */
        this.cancel = function () {
          printModalInstance.close(false);
        };
      }
    });
  }

}
export default angular.module('nodeApp.create', [uiRouter, 'dndLists', HtmlSourceComponent])
  .config(routes)
  .component('create', {
    template: require('./create.html'),
    controller: CreateComponent,
    controllerAs: 'createCtrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/create/create.component.ts